webpackJsonp([4,21],{

/***/ 4:
/***/ function(module, exports) {

	function domake(url, width, height) {
	    var _url = '';
	    var wxReg = /^(https\:\/\/|\/\/)wx\.qlogo\.cn/,
	        imgReg = /^(https\:\/\/|\/\/)img\.58cdn\.com\.cn/,
	        prefixPic = /^(https\:\/\/|\/\/)pic[1-8]/,
	        prifexzzPic = /^(https\:\/\/|\/\/)zzpic/;
	    var re = /^(http\:)/;
	    if (re.test(url)) {
	        url = url.replace(re, "");
	    }
	    if (wxReg.test(url)) {
	        _index = url.lastIndexOf('/');
	        _url = url.substr(0, url.lastIndexOf('/')) + '/96';
	        return _url;
	    } else {
	        if (imgReg.test(url)) {
	            return url;
	        } else if (prefixPic.test(url) || prifexzzPic.test(url)) {
	            var reg = /_\d{2,}_\d{2,}\.(png$|jpg$|gif$)/;
	            if (reg.test(url)) {
	                _url = url.split(url.match(reg)[0])[0];
	            } else {
	                _url = url;
	            }
	        } else if (/^http/.test(url)) {
	            return url;
	        } else {
	            var random = Math.ceil(Math.random() * 8);
	            _url = location.protocol + "//pic" + random + ".58cdn.com.cn/zhuanzh/" + url;
	        }
	        /*var dotIndex = _url.lastIndexOf('.');
	        var suffix = _url.substr(dotIndex, _url.length - 1);
	        var prefix = _url.split(suffix)[0];
	        return prefix + '_' + width + '_' + height + suffix;*/
	        return _url.replace(/(\.png|\.jpg)/, "$1" + "?w=" + width + "&h=" + height);
	    }
	}
	exports.init = function (picUrl, width, height) {
	    var typeofWidth = typeof width;
	    var typeofHeight = typeof height;
	    if (!picUrl) {
	        picUrl = '//img.58cdn.com.cn/zhuanzhuan/images/default_head_icon.png';
	        return picUrl;
	    } else if (typeofWidth !== 'string' && typeofWidth !== 'number' || typeofHeight !== 'string' && typeofWidth !== 'number') {
	        width = 200;
	        height = 200;
	    }
	    if (picUrl instanceof Array) {
	        var newPicArr = [];
	        picUrl.map(function (item, index) {
	            newPicArr.push(domake(item, width, height));
	        });
	        return newPicArr;
	    } else if (typeof picUrl == 'string') {
	        return domake(picUrl, width, height);
	    }
	};
	/**
	* http协议转成成https协议的过滤器
	* */
	exports.formatHttps = function (url) {
	    var re = /^(http)/;
	    if (re.test(url)) {
	        return url.replace(re, "https");
	    }
	    return url;
	};

/***/ },

/***/ 8:
/***/ function(module, exports) {

	//获取滚动条当前的位置
	function getScrollTop() {
	    var scrollTop = 0;
	    if (document.documentElement && document.documentElement.scrollTop) {
	        scrollTop = document.documentElement.scrollTop;
	    } else if (document.body) {
	        scrollTop = document.body.scrollTop;
	    }
	    return scrollTop;
	}
	
	//获取当前可视范围的高度
	function getClientHeight() {
	    var clientHeight = 0;
	    if (document.body.clientHeight && document.documentElement.clientHeight) {
	        clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight);
	    } else {
	        clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight);
	    }
	    return clientHeight;
	}
	
	//获取文档完整的高度
	function getDocHeight() {
	    return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
	}
	exports.init = function () {
	    var current = getScrollTop() + getClientHeight();
	    // 到达底部返回true
	    if (getScrollTop() + getClientHeight() + 20 >= getDocHeight()) {
	        return true;
	    } else {
	        return false;
	    }
	};

/***/ },

/***/ 21:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var adjustPic = __webpack_require__(4);
	var isScrollBottom = __webpack_require__(8);
	var leStatic = __webpack_require__(19);
	var Cookies = __webpack_require__(5);
	module.exports = {
	    props: ['slidemessage', 'orderd'],
	    created: function created() {
	        console.log('slide-load:created');
	        this.onScroll = function () {
	            if (isScrollBottom.init() && !this.gettingData && this.nodata !== 'nodata') {
	                console.log('slideload:scroll');
	                this.gettingData = true;
	                this.modifyInfos(this.slidemessage, "addData");
	            }
	        }.bind(this);
	        this.modifyInfos(this.slidemessage, "newData");
	    },
	    data: function data() {
	        return {
	            bannerUrl: "",
	            bannerSrc: "",
	            infosSlide: [],
	            pagenum: 2,
	            nodata: null,
	            gettingData: false,
	            over: false,
	            scrollTop: 0
	        };
	    },
	    watch: {
	        "slidemessage": function slidemessage(param) {
	            this.nodata = null;
	            this.over = false;
	            console.debug('slideload:slidemessage change');
	            this.modifyInfos(param, "newData");
	        }
	    },
	    activate: function activate(next) {
	        console.log('slide-load:activate');
	        next();
	    },
	    filters: {
	        bannerFilter: function bannerFilter(imgSrc) {
	            if (imgSrc) {
	                return true;
	            } else {
	                return false;
	            }
	        },
	        headImgHandle: function headImgHandle(headImg) {
	            var defaultsrc = "https://img.58cdn.com.cn/zhuanzhuanftp/pic_default_headimg@2x.png";
	            if (headImg == "") {
	                return defaultsrc;
	            }
	            if (typeof headImg == "string") {
	                return adjustPic.init(headImg, 100, 100);
	            } else {
	                return defaultsrc;
	            }
	        },
	        originalPriceHandle: function originalPriceHandle(info) {
	            if ((info.hasOwnProperty("originalPrice") || info.hasOwnProperty("oriPrice")) && info.originalPrice != "" && info.originalPrice != 0) {
	                return true;
	            } else {
	                return false;
	            }
	        }
	    },
	    methods: {
	        goToDetailorder: function goToDetailorder(info) {
	            var product_id = info.strInfoId || info.infoId,
	                pageType = this.orderd ? 'order' : 'detail',
	                paramId = this.orderd ? { order_id: info.orderId } : { product_id: product_id },
	                wubaParamid = this.orderd ? info.orderId : product_id;
	            if (Cookies.get('58ua') == "58app") {
	                leStatic("zzdetail_wxclick");
	                window.location.href = 'https://m.zhuanzhuan.58.com/Mzhuanzhuan/zz58app/' + pageType + '/' + wubaParamid;
	            } else {
	                this.$router.go({
	                    name: pageType,
	                    params: paramId
	                });
	            }
	        },
	        infoImageHandle: function infoImageHandle(infoImage) {
	            var src = "https://img.58cdn.com.cn/zhuanzhuanftp/pic_default_headimg@2x.png";
	            if (typeof infoImage == "string" && infoImage) {
	                if (infoImage.indexOf('|') > -1) {
	                    var _url = infoImage.split('|')[0];
	                    src = adjustPic.init(_url, 210, 210);
	                } else {
	                    src = adjustPic.init(infoImage, 210, 210);
	                }
	            }
	            return src;
	        },
	        hotWordHandle: function hotWordHandle(param) {
	            var url = window.location.href.split("#!")[0];
	            var _href = url + '#!/search/' + param.name;
	            this.$router.go(_href);
	        },
	        onNavClick: function onNavClick(item) {
	            leStatic("MONITOR-HOTCLICK");
	        },
	        modifyInfos: function modifyInfos(paramData, infotype) {
	            var url = paramData.url;
	            var jsonpdata = paramData.params;
	
	            if (infotype == "addData") {
	                for (var k in jsonpdata) {
	                    jsonpdata[k] = k === "pageNumber" || k === "pageNum" || k === "pagenum" ? this.pagenum : jsonpdata[k];
	                }
	                this.pagenum = this.pagenum + 1;
	            } else {
	                this.pagenum = 2;
	            }
	            this.$http.jsonp(url, jsonpdata).then(function (response) {
	                this.reqFlag = true;
	                if (response.data.respCode == "0") {
	                    if (!!response.data.respData) {
	                        var dataArr = !!response.data.respData.infos ? response.data.respData.infos : response.data.respData;
	                        var len = dataArr.length;
	                        var pageData = [];
	                        var num = 0;
	                        var hotRecom = {
	                            flag: false,
	                            keyWords: []
	                        };
	
	                        if (len > 0) {
	                            if (infotype == "newData") {
	                                this.bannerSrc = dataArr[0].hasOwnProperty("imageUrl") ? dataArr[0].imageUrl : "";
	                                this.bannerUrl = dataArr[0].hasOwnProperty("goUrl") ? dataArr[0].goUrl : "";
	                                num = this.bannerSrc == "" ? 0 : 1;
	                                document.body.scrollTop = 0;
	                            }
	                            for (var i = num; i < len - 1; i++) {
	                                pageData.push(dataArr[i]);
	                            }
	                            if (this.pagenum - 1 == 2 || this.pagenum - 1 == 4) {
	                                if (dataArr[len - 1].hasOwnProperty("hotSet")) {
	                                    hotRecom.flag = true;
	                                    hotRecom.keyWords = dataArr[len - 1].hotSet;
	                                    pageData.push(hotRecom);
	                                }
	                            } else {
	                                pageData.push(dataArr[len - 1]);
	                            }
	                            if (this.pagenum - 1 == 3 || this.pagenum - 1 == 5) {
	                                leStatic('MONITOR-HOT');
	                            }
	                            this.infosSlide = infotype == "newData" ? pageData : this.infosSlide.concat(pageData);
	                            if (len < 10) {
	                                this.gettingData = true;
	                                this.over = true;
	                            } else {
	                                this.gettingData = false;
	                            }
	                        } else {
	                            this.gettingData = true;
	                            if (infotype == "newData") {
	                                this.nodata = 'nodata';
	                                this.gettingData = false;
	                                this.infosSlide = [];
	                            } else {
	                                this.over = true;
	                            }
	                        }
	                    } else {
	                        this.gettingData = true;
	                        if (infotype == "newData") {
	                            this.nodata = 'nodata';
	                            this.infosSlide = [];
	                        } else {
	                            this.over = true;
	                        }
	                    }
	                }
	            }, function (response) {
	                console.log("fail" + response.status);
	            });
	        }
	    },
	    events: {
	        startScroll: function startScroll() {
	            setTimeout(function () {
	                window.scrollTo(0, this.scrollTop);
	                console.log('start scroll', this.scrollTop);
	                document.addEventListener('scroll', this.onScroll);
	            }.bind(this), 50);
	        },
	        cancelScroll: function cancelScroll() {
	            this.scrollTop = document.body.scrollTop;
	            console.log('cancel scroll', this.scrollTop);
	            document.removeEventListener('scroll', this.onScroll);
	        },
	        refresh: function refresh(params) {
	            console.log('refresh');
	
	            this.modifyInfos(this.slidemessage, "newData");
	        }
	
	    }
	};

/***/ },

/***/ 26:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "div,form,html,li,p,span,ul{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.hotRecom,.hotRecom li,.hotRecom ul,.infolistWrap,.infolistWrap li{list-style:none;margin:0;padding:0}.hotRecom dd,.hotRecom div,.hotRecom dl,.hotRecom dt,.hotRecom img,.hotRecom li dd,.hotRecom li div,.hotRecom li dl,.hotRecom li dt,.hotRecom li img,.hotRecom li p,.hotRecom p,.hotRecom ul dd,.hotRecom ul div,.hotRecom ul dl,.hotRecom ul dt,.hotRecom ul img,.hotRecom ul p,.infolistWrap dd,.infolistWrap div,.infolistWrap dl,.infolistWrap dt,.infolistWrap img,.infolistWrap li dd,.infolistWrap li div,.infolistWrap li dl,.infolistWrap li dt,.infolistWrap li img,.infolistWrap li p,.infolistWrap p{margin:0;padding:0}.hotRecom a,.hotRecom li a,.hotRecom ul a,.infolistWrap a,.infolistWrap li a{color:inherit;text-decoration:none}.fc{text-align:center}.fr{float:right}.fl{float:left}.home-top-banner,.home-top-banner img{margin:0;padding:0}.home-top-banner{border-top:.53333333rem solid #f1f2f6;border-bottom:.53333333rem solid #f1f2f6;width:100%}.home-top-banner img{vertical-align:top;width:100%}.infolistWrap .info-jumlUrl{display:block;overflow:hidden;padding:.8rem .74666667rem}.infolistWrap li{font-size:.64rem}.infolistWrap li .info-img{width:5.17333333rem;height:5.17333333rem;border:.02666667rem solid #e4e4e4;border-radius:.08rem;margin-right:.58666667rem;background-size:cover;background-repeat:no-repeat;background-position:50%}.infolistWrap li .info-des{width:12.53333333rem}.infolistWrap li .info-title{font-size:.74666667rem;line-height:.96rem;height:1.92rem;color:#292d33;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}.infolistWrap li .info-userWrap{line-height:2.02666667rem;padding-bottom:.26666667rem}.infolistWrap li .info-headImg{width:.8rem;height:.8rem;border-radius:.53333333rem;position:relative;bottom:-.13333333rem}.infolistWrap li .info-nickname{font-size:.64rem;color:#b2b8c2}.infolistWrap li .info-addAndPri{color:#b2b8c2;font-size:.64rem;padding-top:.53333333rem;line-height:1px}.infolistWrap li .info-newPrice{color:#e84345}.infolistWrap li .info-newPrice strong{font-size:1.06666667rem}.infolistWrap li .info-oldPrice{text-decoration:line-through;padding-left:0}.infolistWrap li .info-address{position:relative;bottom:-.18666667rem}.infolistWrap .hotRecom{border-top:.58666667rem solid #f1f2f6;border-bottom:.58666667rem solid #f1f2f6;padding:.85333333rem 0;color:#64686f}.infolistWrap .hotRecom li a{display:inline-block}.infolistWrap .hotRecom ul{overflow:hidden}.infolistWrap .hotRecom .hotRecom-title{font-size:.74666667rem;color:#292d33;padding-left:.64rem;border-left:.10666667rem solid #e84345;font-weight:700}.infolistWrap .hotRecom .hotRecom-word{display:inline-block;margin:.53333333rem 0 0 .8rem;width:5.54666667rem;height:1.86666667rem;line-height:1.86666667rem;text-align:center;border:1px solid #b2b8c2;font-size:.69333333rem}.nodata{background-color:#f1f2f6;text-align:center;position:absolute;top:4.74666667rem;bottom:0;left:0;right:0}.nodata img{display:block;margin:7.49333333rem auto 0;border:none;height:5.33333333rem;width:5.33333333rem}.nodata p{font-size:.74666667rem;color:#848d99}.loading{text-align:center;font-size:.64rem;color:#666;line-height:1.6rem;height:1.6rem}", "", {"version":3,"sources":["/./src/components/SlideLoad/SlideLoad.vue"],"names":[],"mappings":"AAAA,2BAA2B,yBAAyB,sBAAsB,qBAAqB,gBAAgB,CAAC,mEAAmE,gBAAgB,SAAS,SAAS,CAAC,ifAAif,SAAS,SAAS,CAAC,6EAA6E,cAAc,oBAAoB,CAAC,IAAI,iBAAiB,CAAC,IAAI,WAAW,CAAC,IAAI,UAAU,CAAC,sCAAsC,SAAS,SAAS,CAAC,iBAAiB,sCAAsC,yCAAyC,UAAU,CAAC,qBAAqB,mBAAmB,UAAU,CAAC,4BAA4B,cAAc,gBAAgB,0BAA0B,CAAC,iBAAiB,gBAAgB,CAAC,2BAA2B,oBAAoB,qBAAqB,kCAAkC,qBAAqB,0BAA0B,sBAAsB,4BAA4B,uBAAiC,CAAC,2BAA2B,oBAAoB,CAAC,6BAA6B,uBAAuB,mBAAmB,eAAe,cAAc,gBAAgB,uBAAuB,oBAAoB,qBAAqB,2BAA2B,CAAC,gCAAgC,0BAA0B,2BAA2B,CAAC,+BAA+B,YAAY,aAAa,2BAA2B,kBAAkB,oBAAqB,CAAC,gCAAgC,iBAAiB,aAAa,CAAC,iCAAiC,cAAc,iBAAiB,yBAAyB,eAAe,CAAC,gCAAgC,aAAa,CAAC,uCAAuC,uBAAuB,CAAC,gCAAgC,6BAA6B,cAAc,CAAC,+BAA+B,kBAAkB,oBAAqB,CAAC,wBAAwB,sCAAsC,yCAAyC,uBAAuB,aAAa,CAAC,6BAA6B,oBAAoB,CAAC,2BAA2B,eAAe,CAAC,wCAAwC,uBAAuB,cAAc,oBAAoB,uCAAuC,eAAgB,CAAC,uCAAuC,qBAAqB,8BAA8B,oBAAoB,qBAAqB,0BAA0B,kBAAkB,yBAAyB,sBAAsB,CAAC,QAAQ,yBAAyB,kBAAkB,kBAAkB,kBAAkB,SAAS,OAAO,OAAO,CAAC,YAAY,cAAc,4BAAiC,YAAY,qBAAqB,mBAAmB,CAAC,UAAU,uBAAuB,aAAa,CAAC,SAAS,kBAAkB,iBAAiB,WAAc,mBAAmB,aAAa,CAAC","file":"SlideLoad.vue","sourcesContent":["html,div,p,ul,li,form,span{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.infolistWrap,.infolistWrap li,.hotRecom,.hotRecom ul,.hotRecom li{list-style:none;margin:0;padding:0}.infolistWrap dl,.infolistWrap li dl,.hotRecom dl,.hotRecom ul dl,.hotRecom li dl,.infolistWrap dt,.infolistWrap li dt,.hotRecom dt,.hotRecom ul dt,.hotRecom li dt,.infolistWrap dd,.infolistWrap li dd,.hotRecom dd,.hotRecom ul dd,.hotRecom li dd,.infolistWrap p,.infolistWrap li p,.hotRecom p,.hotRecom ul p,.hotRecom li p,.infolistWrap div,.infolistWrap li div,.hotRecom div,.hotRecom ul div,.hotRecom li div,.infolistWrap img,.infolistWrap li img,.hotRecom img,.hotRecom ul img,.hotRecom li img{margin:0;padding:0}.infolistWrap a,.infolistWrap li a,.hotRecom a,.hotRecom ul a,.hotRecom li a{color:inherit;text-decoration:none}.fc{text-align:center}.fr{float:right}.fl{float:left}.home-top-banner,.home-top-banner img{margin:0;padding:0}.home-top-banner{border-top:.53333333rem solid #F1F2F6;border-bottom:.53333333rem solid #F1F2F6;width:100%}.home-top-banner img{vertical-align:top;width:100%}.infolistWrap .info-jumlUrl{display:block;overflow:hidden;padding:.8rem .74666667rem}.infolistWrap li{font-size:.64rem}.infolistWrap li .info-img{width:5.17333333rem;height:5.17333333rem;border:.02666667rem solid #E4E4E4;border-radius:.08rem;margin-right:.58666667rem;background-size:cover;background-repeat:no-repeat;background-position:center center}.infolistWrap li .info-des{width:12.53333333rem}.infolistWrap li .info-title{font-size:.74666667rem;line-height:.96rem;height:1.92rem;color:#292D33;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}.infolistWrap li .info-userWrap{line-height:2.02666667rem;padding-bottom:.26666667rem}.infolistWrap li .info-headImg{width:.8rem;height:.8rem;border-radius:.53333333rem;position:relative;bottom:-0.13333333rem}.infolistWrap li .info-nickname{font-size:.64rem;color:#B2B8C2}.infolistWrap li .info-addAndPri{color:#B2B8C2;font-size:.64rem;padding-top:.53333333rem;line-height:1px}.infolistWrap li .info-newPrice{color:#E84345}.infolistWrap li .info-newPrice strong{font-size:1.06666667rem}.infolistWrap li .info-oldPrice{text-decoration:line-through;padding-left:0}.infolistWrap li .info-address{position:relative;bottom:-0.18666667rem}.infolistWrap .hotRecom{border-top:.58666667rem solid #F1F2F6;border-bottom:.58666667rem solid #F1F2F6;padding:.85333333rem 0;color:#64686F}.infolistWrap .hotRecom li a{display:inline-block}.infolistWrap .hotRecom ul{overflow:hidden}.infolistWrap .hotRecom .hotRecom-title{font-size:.74666667rem;color:#292D33;padding-left:.64rem;border-left:.10666667rem solid #E84345;font-weight:bold}.infolistWrap .hotRecom .hotRecom-word{display:inline-block;margin:.53333333rem 0 0 .8rem;width:5.54666667rem;height:1.86666667rem;line-height:1.86666667rem;text-align:center;border:1px solid #B2B8C2;font-size:.69333333rem}.nodata{background-color:#f1f2f6;text-align:center;position:absolute;top:4.74666667rem;bottom:0;left:0;right:0}.nodata img{display:block;margin:7.49333333rem auto 0 auto;border:none;height:5.33333333rem;width:5.33333333rem}.nodata p{font-size:.74666667rem;color:#848d99}.loading{text-align:center;font-size:.64rem;color:#666666;line-height:1.6rem;height:1.6rem}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },

/***/ 28:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(26);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js!../../../node_modules/less-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./SlideLoad.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js!../../../node_modules/less-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./SlideLoad.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 30:
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },

/***/ 32:
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=slide-load> <ul class=infolistWrap v-if=\"infosSlide.length>0\"> <li v-for=\"info in infosSlide\"> <template v-if=info.flag> <div class=hotRecom> <p class=hotRecom-title>热门推荐</p> <ul> <li v-for=\"item in info.keyWords\" class=fl> <a v-link=\"{ name: 'search', params: { keyword: item.name }}\" v-touch:tap=onNavClick(item.name)><span class=hotRecom-word>{{item.name}}</span></a> </li> </ul> </div> </template> <template v-else> <a @click=goToDetailorder(info) class=info-jumlUrl> <div :style=\"{'background-image' : 'url(' + infoImageHandle(info.infoImage || info.infoPics || info.pics) + ')'}\" class=\"fl info-img\"></div> <dl class=\"fl info-des\"> <dt class=info-title>{{info.title || info.infoTitle}}{{info.desc }}</dt> <dd class=info-userWrap> <img :src=\"info.headImg || info.userPic | headImgHandle\" class=info-headImg> <span class=info-nickname>{{info.nickName || info.userNickName}}</span> </dd> <dd class=info-addAndPri> <span class=info-newPrice>￥<strong>{{info.price || info.nowPrice}}</strong></span> <span class=info-oldPrice v-if=\"info | originalPriceHandle \">原价{{info.originalPrice || info.oriPrice}}</span> <span v-if=!orderd class=\"fr info-address\">{{info.cityName}} | {{info.businessName || info.areaName}}</span> </dd> </dl> </a> </template> </li> </ul> <div class=loading v-show=\"gettingData && !over\">正在加载数据，请稍等</div> <div class=loading v-show=over>已经到底了</div> <div v-if=\"nodata=='nodata' \" class=nodata> <img src=" + __webpack_require__(30) + "> <p>没有找到相关宝贝</p> </div> </div>";

/***/ },

/***/ 33:
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(28)
	__vue_script__ = __webpack_require__(21)
	__vue_template__ = __webpack_require__(32)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },

/***/ 42:
/***/ function(module, exports) {

	/**
	 * Created by zhj on 16/9/9.
	 */
	function daojiaLog(bi_params, logtype) {
	    var log_url = "https://static.daojia.com/bi/buried_point/js/tracker.js?r=" + Math.random() + "&logv=1.1&type=" + logtype;
	    if (bi_params != null) {
	        for (var key in bi_params) {
	            log_url += "&" + key + "=" + bi_params[key];
	        }
	        new Image().src = log_url;
	    }
	}
	module.exports = daojiaLog;

/***/ },

/***/ 47:
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(73)
	__vue_script__ = __webpack_require__(56)
	__vue_template__ = __webpack_require__(81)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },

/***/ 55:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	    name: 'search-manage',
	    data: function data() {
	        return {
	            searchHotWord: [],
	            searchRecord: [],
	            searchtype: 'searchManage'
	        };
	    },
	    props: ["keyword"],
	    created: function created() {
	        this.$http.jsonp('getSearchHotWord').then(function (response) {
	            this.searchHotWord = response.data.respData;
	        });
	        this.$http.jsonp('getSearchRecord').then(function (response) {
	            this.searchRecord = response.data.respData;
	
	            this.searchRecord.forEach(function (value) {
	                value.searchContent = decodeURIComponent(value.searchContent.replace(/%(25)+/g, '%'));
	            });
	        });
	    },
	    methods: {
	        search: function search(message) {
	            if (message.trim().length > 0) {
	                message = decodeURIComponent(message.replace(/%(25)+/g, ''));
	                this.$router.go({ name: 'search', params: { keyword: message } });
	            }
	        },
	        clearSearch: function clearSearch() {
	            if (confirm('确定要清除吗？')) {
	                this.$http.jsonp('clearSearchRecord').then(function (response) {
	                    if (response.data.respCode == 0) {
	                        this.searchRecord = [];
	                    }
	                });
	            }
	        }
	    },
	    components: {
	        'top-search': __webpack_require__(47)
	    },
	    ready: function ready() {}
	
	};

/***/ },

/***/ 56:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Vue = __webpack_require__(48);
	var Cookies = __webpack_require__(5);
	var localStore = __webpack_require__(14).local;
	var isLogin = __webpack_require__(35).mixin.methods.isLogin;
	module.exports = {
	    data: function data() {
	        return {
	            searchSuggest: [],
	            numAll: 0,
	            commentmsgnum: 0,
	            ordermsgnum: 0,
	            chatmsgnum: 0,
	            systemmsgnum: 0,
	            source: 24,
	            loginFlag: false,
	            uid: ""
	        };
	    },
	    filters: {
	        messageNumFilter: function messageNumFilter(num) {
	            if (num == 0) {
	                return false;
	            } else {
	                return true;
	            }
	        }
	    },
	    methods: {
	        onSubmit: function onSubmit() {
	            var keyword = this.keyword.trim();
	            if (keyword.length > 0) {
	                this.$dispatch('toHideManager');
	                this.$nextTick(function () {
	                    document.getElementById('searchM').blur();
	                });
	                this.$router.go({ name: 'search', params: { keyword: keyword } });
	            }
	        },
	        getInformation: function getInformation() {
	            var self = this;
	
	            if (isLogin()) {
	                this.numAll = 0;
	
	                this.$http.jsonp("getUnreadInfoCommentsCount").then(function (response1) {
	                    if (response1.data.respCode == "0" && !!response1.data.respData) {
	                        var commentmsgnum = parseInt(response1.data.respData.count, 10);
	                        this.numAll += commentmsgnum;
	
	                        if (this.numAll) {
	                            return this.numAll;
	                        }
	
	                        this.$http.jsonp("getOrderUnread").then(function (response) {
	                            if (response.data.respCode == "0" && !!response.data.respData) {
	                                var ordermsgnum = parseInt(response.data.respData.cnt);
	                                this.numAll += ordermsgnum;
	                                if (this.numAll) {
	                                    return this.numAll;
	                                }
	
	                                if (!this.loginFlag) {
	                                    console.log('not login');
	                                    var url = "//grzhuanzhuan.58.com/user_login";
	                                    var params = {
	                                        uid: this.uid,
	                                        source: this.source,
	                                        pc_code: "weixin",
	                                        client_version: "1.0.0"
	                                    };
	                                    this.$http.jsonp(url, params).then(function (response) {
	                                        if (response.data.code == "200000") {
	                                            this.loginNum = 0;
	                                            this.loginFlag = true;
	                                            this.getChatAndSystemMsgNum();
	                                        }
	                                    });
	                                } else {
	                                    console.log('already login');
	                                    this.getChatAndSystemMsgNum();
	                                }
	                            }
	                        }, function (response) {
	                            console.log("fail" + response.status);
	                        });
	                    }
	                }, function (response) {
	                    console.log("fail" + response.status);
	                });
	            } else {
	                console.log('isLogin is false');
	            }
	        },
	        getChatAndSystemMsgNum: function getChatAndSystemMsgNum() {
	            var chatMsgList = localStore.get("chatList") ? localStore.get("chatList") : {};
	            var num = 0;
	            var chatMsgObj = !!chatMsgList[this.uid] ? chatMsgList[this.uid] : {};
	            for (var key in chatMsgObj) {
	                num += chatMsgObj[key] ? chatMsgObj[key] : 0;
	            }
	            self.chatmsgnum = num;
	            this.numAll += +self.chatmsgnum;
	            if (this.numAll) {
	                return this.numAll;
	            }
	            var url = "//grzhuanzhuan.58.com/getofflinemsgcount";
	            var params = {
	                source: this.source,
	                uid: this.uid,
	                msgtype: 10
	            };
	            params.msgtype = 39;
	            this.$http.jsonp(url, params).then(function (response) {
	                if (response.data.code == "200000") {
	                    self.systemmsgnum = parseInt(response.data.protocol_content.msg_count);
	                    this.numAll += +self.systemmsgnum;
	                    if (this.numAll) {
	                        return this.numAll;
	                    }
	                }
	            }, function (response) {
	                console.log("fail" + response.status);
	            });
	        },
	        onKeywordChange: function onKeywordChange() {
	            var keyword = this.keyword.trim();
	            if (keyword) {
	                this.$http.jsonp('searchSuggest', { inputText: keyword }).then(function (response) {
	                    if (response.data.respCode == 0) {
	                        this.searchSuggest = response.data.respData || [];
	                    } else {
	                        this.searchSuggest = [];
	                    }
	                });
	            } else {
	                this.searchSuggest = [];
	            }
	        },
	        goSearchManage: function goSearchManage() {
	            this.$dispatch('toShowManger');
	            this.$nextTick(function () {
	                document.getElementById('searchM').focus();
	            });
	        },
	        onSuggestClick: function onSuggestClick(keyword) {
	            this.keyword = keyword;
	            if (keyword.trim().length > 0) {
	                this.$router.go({ name: 'search', params: { keyword: keyword }, replace: true });
	            }
	        },
	        hide: function hide() {
	            this.$dispatch('toHideManager');
	        }
	    },
	    props: {
	        searchtype: {
	            type: String
	        },
	        keyword: {
	            type: String,
	            default: ''
	        }
	    },
	    ready: function ready() {
	        this.searchSuggest = [];
	    },
	    events: {
	        getInformation: function getInformation() {
	            console.debug('uid', Cookies.getUID());
	            this.uid = Cookies.getUID() || '';
	            this.getInformation();
	        }
	    }
	
	};

/***/ },

/***/ 70:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "div,form,html,li,p,span,ul{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.searchManage div,.searchManage h3,.searchManage h4,.searchManage img,.searchManage li,.searchManage ul{margin:0;padding:0}.searchManage li,.searchManage ul{list-style:none}.searchManage{background:#f1f2f6;position:absolute;left:0;right:0;bottom:0;height:100%;top:0}#searchManage{height:100%}#searchManage .hotSearchWord{padding-left:.74666667rem;font-size:.74666667rem;border-top:1px solid #e8ebf0}#searchManage .hotSearchWord h3{color:#848c99;font-size:.74666667rem;line-height:2.29333333rem;height:2.29333333rem;font-weight:400}#searchManage .hotSearchWord ul{overflow:hidden}#searchManage .hotSearchWord li{width:5.86666667rem;height:1.92rem;background:#fff;line-height:1.92rem;float:left;margin-right:.42666667rem;margin-bottom:.37333333rem;text-align:center}#searchManage .searchRecord{background:#f1f2f6;padding:.8rem 0 .8rem .74666667rem;font-size:.74666667rem}#searchManage .searchRecord h3{color:#848c99;font-size:.74666667rem;line-height:2.29333333rem;height:2.29333333rem;border-bottom:1px solid #d1d1d1;font-weight:400}#searchManage .searchRecord ul{overflow:hidden}#searchManage .searchRecord li{line-height:2.66666667rem;height:2.66666667rem;border-bottom:1px solid #d1d1d1;color:#292d33;overflow:hidden}#searchManage .searchRecord .clearRecord{background:#e6454a;height:2.18666667rem;line-height:2.18666667rem;color:#fff;text-align:center;font-size:.85333333rem;margin-right:.74666667rem;border-radius:5px;margin-top:1.06666667rem}@-webkit-keyframes slideFromRight{0%{-webkit-transform:translateX(100%);transform:translateX(100%)}}@keyframes slideFromRight{0%{-webkit-transform:translateX(100%);transform:translateX(100%)}}@-webkit-keyframes slideToRight{to{-webkit-transform:translateX(100%);transform:translateX(100%)}}.search-manage-transition{z-index:1999}.search-manage-enter{-webkit-animation:slideFromRight .3s forwards ease-in-out;animation:slideFromRight .3s forwards ease-in-out}.search-manage-leave{-webkit-animation:slideToRight .3s forwards ease-in-out;animation:slideToRight .3s forwards ease-in-out}", "", {"version":3,"sources":["/./src/components/SearchManager/SearchManager.vue"],"names":[],"mappings":"AAAA,2BAA2B,yBAAyB,sBAAsB,qBAAqB,gBAAgB,CAAC,wGAAwG,SAAS,SAAS,CAAC,kCAAkC,eAAe,CAAC,cAAc,mBAAmB,kBAAkB,OAAO,QAAQ,SAAS,YAAY,KAAK,CAAC,cAAc,WAAW,CAAC,6BAA6B,0BAA0B,uBAAuB,4BAA4B,CAAC,gCAAgC,cAAc,uBAAuB,0BAA0B,qBAAqB,eAAkB,CAAC,gCAAgC,eAAe,CAAC,gCAAgC,oBAAoB,eAAe,gBAAmB,oBAAoB,WAAW,0BAA0B,2BAA2B,iBAAiB,CAAC,4BAA4B,mBAAmB,mCAAmC,sBAAsB,CAAC,+BAA+B,cAAc,uBAAuB,0BAA0B,qBAAqB,gCAAgC,eAAkB,CAAC,+BAA+B,eAAe,CAAC,+BAA+B,0BAA0B,qBAAqB,gCAAgC,cAAc,eAAe,CAAC,yCAAyC,mBAAmB,qBAAqB,0BAA0B,WAAc,kBAAkB,uBAAuB,0BAA0B,kBAAkB,wBAAwB,CAAC,kCAAkC,GAAK,mCAAmC,0BAA0B,CAAC,CAAC,0BAA0B,GAAK,mCAAmC,0BAA0B,CAAC,CAAC,gCAAgC,GAAG,mCAAmC,0BAA0B,CAAC,CAAC,0BAA0B,YAAY,CAAC,qBAAqB,0DAA4D,iDAAmD,CAAC,qBAAqB,wDAA0D,+CAAiD,CAAC","file":"SearchManager.vue","sourcesContent":["html,div,p,ul,li,form,span{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.searchManage div,.searchManage ul,.searchManage li,.searchManage img,.searchManage h3,.searchManage h4{margin:0;padding:0}.searchManage ul,.searchManage li{list-style:none}.searchManage{background:#f1f2f6;position:absolute;left:0;right:0;bottom:0;height:100%;top:0}#searchManage{height:100%}#searchManage .hotSearchWord{padding-left:.74666667rem;font-size:.74666667rem;border-top:1px solid #E8EBF0}#searchManage .hotSearchWord h3{color:#848c99;font-size:.74666667rem;line-height:2.29333333rem;height:2.29333333rem;font-weight:normal}#searchManage .hotSearchWord ul{overflow:hidden}#searchManage .hotSearchWord li{width:5.86666667rem;height:1.92rem;background:#ffffff;line-height:1.92rem;float:left;margin-right:.42666667rem;margin-bottom:.37333333rem;text-align:center}#searchManage .searchRecord{background:#f1f2f6;padding:.8rem 0 .8rem .74666667rem;font-size:.74666667rem}#searchManage .searchRecord h3{color:#848c99;font-size:.74666667rem;line-height:2.29333333rem;height:2.29333333rem;border-bottom:1px solid #D1D1D1;font-weight:normal}#searchManage .searchRecord ul{overflow:hidden}#searchManage .searchRecord li{line-height:2.66666667rem;height:2.66666667rem;border-bottom:1px solid #D1D1D1;color:#292d33;overflow:hidden}#searchManage .searchRecord .clearRecord{background:#e6454a;height:2.18666667rem;line-height:2.18666667rem;color:#ffffff;text-align:center;font-size:.85333333rem;margin-right:.74666667rem;border-radius:5px;margin-top:1.06666667rem}@-webkit-keyframes slideFromRight{from{-webkit-transform:translateX(100%);transform:translateX(100%)}}@keyframes slideFromRight{from{-webkit-transform:translateX(100%);transform:translateX(100%)}}@-webkit-keyframes slideToRight{to{-webkit-transform:translateX(100%);transform:translateX(100%)}}.search-manage-transition{z-index:1999}.search-manage-enter{-webkit-animation:slideFromRight 300ms forwards ease-in-out;animation:slideFromRight 300ms forwards ease-in-out}.search-manage-leave{-webkit-animation:slideToRight 300ms forwards ease-in-out;animation:slideToRight 300ms forwards ease-in-out}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },

/***/ 71:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "div,form,html,li,p,span,ul{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#TopSearch ul li{list-style:none}.searchFixed{position:fixed;top:0;z-index:99}#TopSearch{z-index:1000;background:#fff;padding:.42666667rem 0 .42666667rem .74666667rem;font-size:.74666667rem;border-bottom:1px solid #e8ebf0;overflow:hidden}#TopSearch form{float:left}#TopSearch .fake-input,#TopSearch input{border:none;outline:medium;height:1.54666667rem;background:#f1f2f6;color:#b2b8c2;float:left;padding:.13333333rem 0 .13333333rem .53333333rem;border:1px solid #e8ebf0;border-radius:.13333333rem;-webkit-appearance:none;margin-right:.74666667rem;font-size:.74666667rem}#TopSearch .fake-input{line-height:1.54666667rem}#TopSearch .info-num{border-radius:50%;width:.56rem;height:.56rem;background:#e86464;position:absolute;left:95.5%;margin-top:-.26666667rem}#TopSearch .search-suggest{position:absolute;top:2.93333333rem;left:0;bottom:0;background:#f1f2f6;width:100%;z-index:100}#TopSearch .search-suggest ul{overflow:hidden;padding-left:.8rem;background:#f1f2f6}#TopSearch .search-suggest li{line-height:2.66666667rem;height:2.66666667rem;border-bottom:1px solid #d1d1d1;color:#292d33;background:#f1f2f6}#TopSearch #searchBlur{overflow:hidden}#TopSearch #searchBlur input{width:16rem;color:#9a9a9a;margin-right:.53333333rem}#TopSearch #searchRouter .fake-input{width:16.02666667rem;overflow:hidden}#TopSearch #searchRouter .fake-input .icon_search{display:inline-block;width:.74666667rem;height:.74666667rem;background:url(" + __webpack_require__(78) + ") no-repeat;background-size:cover;vertical-align:-.16rem;margin-right:.4rem}.top-search-cancel{color:#e6454a;display:block;float:left;height:1.92rem;line-height:1.92rem}.top-search-message{display:block;float:left;background:url(" + __webpack_require__(79) + ") no-repeat 0 0;background-size:1.12rem auto;height:.93333333rem;width:1.12rem;margin-top:.53333333rem}#TopSearch #searchClick input{width:14.13333333rem}#TopSearch #searchClick button{width:3.73333333rem;background:#e6454a;color:#fff;font-size:.74666667rem;text-align:center;border-radius:.21333333rem;-webkit-appearance:none;padding:0;display:block;float:left;height:1.81333333rem;line-height:1.81333333rem;border:none}", "", {"version":3,"sources":["/./src/components/TopSearch/TopSearch.vue"],"names":[],"mappings":"AAAA,2BAA2B,yBAAyB,sBAAsB,qBAAqB,gBAAgB,CAAC,iBAAiB,eAAe,CAAC,aAAa,eAAe,MAAM,UAAU,CAAC,WAAW,aAAa,gBAAmB,iDAAiD,uBAAuB,gCAAgC,eAAe,CAAC,gBAAgB,UAAU,CAAC,wCAAwC,YAAY,eAAe,qBAAqB,mBAAmB,cAAc,WAAW,iDAAiD,yBAAyB,2BAA2B,wBAAwB,0BAA0B,sBAAsB,CAAC,uBAAuB,yBAAyB,CAAC,qBAAqB,kBAAkB,aAAa,cAAc,mBAAmB,kBAAkB,WAAW,wBAAyB,CAAC,2BAA2B,kBAAkB,kBAAkB,OAAO,SAAS,mBAAmB,WAAW,WAAW,CAAC,8BAA8B,gBAAgB,mBAAmB,kBAAkB,CAAC,8BAA8B,0BAA0B,qBAAqB,gCAAgC,cAAc,kBAAkB,CAAC,uBAAuB,eAAe,CAAC,6BAA6B,YAAY,cAAc,yBAAyB,CAAC,qCAAqC,qBAAqB,eAAe,CAAC,kDAAkD,qBAAqB,mBAAmB,oBAAoB,mDAA0C,sBAAsB,uBAAwB,kBAAkB,CAAC,mBAAmB,cAAc,cAAc,WAAW,eAAe,mBAAmB,CAAC,oBAAoB,cAAc,WAAW,uDAAuC,6BAA6B,oBAAoB,cAAc,uBAAuB,CAAC,8BAA8B,oBAAoB,CAAC,+BAA+B,oBAAoB,mBAAmB,WAAc,uBAAuB,kBAAkB,2BAA2B,wBAAwB,UAAU,cAAc,WAAW,qBAAqB,0BAA0B,WAAW,CAAC","file":"TopSearch.vue","sourcesContent":["html,div,p,ul,li,form,span{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#TopSearch ul li{list-style:none}.searchFixed{position:fixed;top:0;z-index:99}#TopSearch{z-index:1000;background:#ffffff;padding:.42666667rem 0 .42666667rem .74666667rem;font-size:.74666667rem;border-bottom:1px solid #E8EBF0;overflow:hidden}#TopSearch form{float:left}#TopSearch input,#TopSearch .fake-input{border:none;outline:medium;height:1.54666667rem;background:#f1f2f6;color:#b2b8c2;float:left;padding:.13333333rem 0 .13333333rem .53333333rem;border:1px solid #E8EBF0;border-radius:.13333333rem;-webkit-appearance:none;margin-right:.74666667rem;font-size:.74666667rem}#TopSearch .fake-input{line-height:1.54666667rem}#TopSearch .info-num{border-radius:50%;width:.56rem;height:.56rem;background:#E86464;position:absolute;left:95.5%;margin-top:-0.26666667rem}#TopSearch .search-suggest{position:absolute;top:2.93333333rem;left:0;bottom:0;background:#f1f2f6;width:100%;z-index:100}#TopSearch .search-suggest ul{overflow:hidden;padding-left:.8rem;background:#f1f2f6}#TopSearch .search-suggest li{line-height:2.66666667rem;height:2.66666667rem;border-bottom:1px solid #D1D1D1;color:#292d33;background:#f1f2f6}#TopSearch #searchBlur{overflow:hidden}#TopSearch #searchBlur input{width:16rem;color:#9a9a9a;margin-right:.53333333rem}#TopSearch #searchRouter .fake-input{width:16.02666667rem;overflow:hidden}#TopSearch #searchRouter .fake-input .icon_search{display:inline-block;width:.74666667rem;height:.74666667rem;background:url(icon_search.png) no-repeat;background-size:cover;vertical-align:-0.16rem;margin-right:.4rem}.top-search-cancel{color:#e6454a;display:block;float:left;height:1.92rem;line-height:1.92rem}.top-search-message{display:block;float:left;background:url(tips.png) no-repeat 0 0;background-size:1.12rem auto;height:.93333333rem;width:1.12rem;margin-top:.53333333rem}#TopSearch #searchClick input{width:14.13333333rem}#TopSearch #searchClick button{width:3.73333333rem;background:#e6454a;color:#ffffff;font-size:.74666667rem;text-align:center;border-radius:.21333333rem;-webkit-appearance:none;padding:0;display:block;float:left;height:1.81333333rem;line-height:1.81333333rem;border:none}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },

/***/ 72:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(70);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js!../../../node_modules/less-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./SearchManager.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js!../../../node_modules/less-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./SearchManager.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 73:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(71);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js!../../../node_modules/less-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./TopSearch.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js!../../../node_modules/less-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./TopSearch.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 78:
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAqpJREFUeNq8l01oE0EUxzdSxA9oI1gQoaIgCBVaigfx4EGNUNAi1outF1Fro2A92VpBD37biwhq04oeRCweDCgiAYMHDwqCUKv1oAfFIogK1ooKBY3/B7+FRZxkN83mwY+d7M68+U/2zb43ibu5R14JqxPtIiVWiUXc+yY+imciL7Lci2Q1RZ4lRa84KOY5hBkrRKe4KC6IATEZVsAsx/3t4o3oF3NY4X7RIhaIBNcW7ufp18+4jnIFmOOzYkQsFPdFk9goBsVoYHWT/B7keRP9bdxN/CSiCjgt+sS0SItNYjzkYsbpn2Z8H/5CC7C//TCDt4ghrzwbYvw0/jrCCKgXl2kfEDlvZpbDj4ff+lICjhJU9g6HvcrYMP5sNx0rJsC20h7xh21XSTuE393M818B9pGZKx5GCLiw9gq/5n+bS0CKdtaLx3y/KZeAZtpPYhLg+21yCWig/S4mAW+5NrgE1Aa+bHGYn6BqXQKmAsknDvOj/7tLwATtpTEJWMZ1wiXgOe01MQnw/Y66BORpt8ckYCvXvEuA7dNfYr1YWeHJG8UG/GddAixKr9I+V2EBA/i94irX/GR0gm1o+byrQpN34e+rOFkqG36itPKo7VpnOHkrfsz2ic9hCpIRyqjZ4o7oLnPybsabn/PiVpSS7AhxYIMz4l6EwGykf4bxZm1ieRQBBcqoHeIL73BMPKDWaw582er4neb5i8A73yueMvljsdolIFHkYJKksOxxnAv+tZ/spuOIn89rbeNZJ68m1LnAT05W5y+morFS+zW5o0DgvmSSXfTrYXKzH3yEMizgdiDQQ52MgtnsGkS13+yC9+KUuCSWsLBCqX+gknZG7AycF274gVotAWbXCdIp4sFK92Q1BfgJaa34INaZkBqv+jZGit5s58q/AgwA7J+UKCLqobcAAAAASUVORK5CYII="

/***/ },

/***/ 79:
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },

/***/ 80:
/***/ function(module, exports) {

	module.exports = "<div class=searchManage transition=search-manage> <div id=searchManage> <top-search :searchtype=searchtype :keyword.sync=keyword></top-search> <div class=hotSearchWord v-if=\"searchHotWord.length>0\"> <h3>热门搜索</h3> <ul> <li v-for=\"value in searchHotWord\" @click=search(value.searchWord)>{{value.searchWord}}</li> </ul> </div> <div class=searchRecord v-if=\"searchRecord.length>0\"> <h3>历史搜索</h3> <ul> <li v-for=\"value in searchRecord\" @click=search(value.searchContent)>{{value.searchContent}}</li> </ul> <div class=clearRecord @click=clearSearch()>清除搜索记录</div> </div> </div> </div>";

/***/ },

/***/ 81:
/***/ function(module, exports) {

	module.exports = "<div id=TopSearch class={{searchFixed}}> <div id=searchBlur v-if=\"searchtype == 'searchManage'\"> <form @submit.prevent=onSubmit> <input type=text v-el:searchblur v-model=keyword placeholder=请输入物品名称等关键词 name=keyword @keyup=onKeywordChange autocomplete=off id=searchM> </form> <span class=top-search-cancel @click=hide()>取消</span> </div> <div id=searchRouter v-if=\"searchtype == 'searchRouter'\"> <div type=text autocomplete=off class=fake-input @click=goSearchManage()> <i class=icon_search></i>{{keyword}} </div> <a class=top-search-message v-link=\"{ name: 'message'}\"><span class=info-num v-if=\"numAll | messageNumFilter\"></span></a> </div> <div v-show=\"searchSuggest.length > 0\" class=search-suggest> <ul> <li v-for=\"item in searchSuggest\" @click=onSuggestClick(item.k)>{{item.k}}</li> </ul> </div> </div>";

/***/ },

/***/ 82:
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(72)
	__vue_script__ = __webpack_require__(55)
	__vue_template__ = __webpack_require__(80)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },

/***/ 101:
/***/ function(module, exports) {

	module.exports = [{
	    cateid: null,
	    cateName: '全部',
	    subName: '都在这里'
	}, {
	    cateid: '111|112|114',
	    cateName: '女生',
	    subName: '美容/鞋服/珠宝'
	}, {
	    cateid: '109',
	    cateName: '母婴',
	    subName: '母婴用品/玩具'
	}, {
	    cateid: '101|102|103',
	    cateName: '数码',
	    subName: '手机/电脑/数码'
	}, {
	    cateid: '107|108',
	    cateName: '居家',
	    subName: '家具/家居/家电'
	}, {
	    cateid: '105|106',
	    cateName: '有车族',
	    subName: '代步工具/车载'
	}, {
	    cateid: '110',
	    cateName: '运动',
	    subName: '运动/户外'
	}, {
	    cateid: '113|115|116',
	    cateName: '文青',
	    subName: '图书/票务/乐器'
	}, {
	    cateid: '117|118|100|104',
	    cateName: '大杂烩',
	    subName: '文具/古玩/宠物'
	}];

/***/ },

/***/ 121:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var daojiaLog = __webpack_require__(42);
	module.exports = {
	    name: 'home',
	    data: function data() {
	        return {
	            cateid: null,
	            homeNavMessage: "",
	            isShowMenu: false,
	            searchtype: 'searchRouter',
	            keyword: '请输入物品名称等关键词',
	            menuList: __webpack_require__(101),
	            showManager: false
	        };
	    },
	    ready: function ready() {
	        daojiaLog({ pagetype: 'zhuanzhuan_list' }, 'pageview');
	    },
	    computed: {
	        paramArr: function paramArr() {
	            return {
	                type: "navData",
	                url: "getRecommendForWeChat",
	                params: {
	                    pagenum: 1,
	                    pagesize: 10,
	                    cateid: this.cateid
	                }
	            };
	        }
	    },
	    created: function created() {
	        var _this = this;
	
	        window.onpopstate = function (event) {
	            console.log('popstate');
	
	            _this.showManager = false;
	        };
	    },
	    methods: {
	        onMenuChange: function onMenuChange(cateid) {
	            var route;
	
	            if (cateid) {
	                route = {
	                    name: 'category',
	                    params: {
	                        cateid: cateid
	                    }
	                };
	            } else {
	                route = {
	                    name: 'home',
	                    params: {}
	                };
	            }
	            console.log(route);
	            this.$router.go(route);
	        },
	        keywordChange: function keywordChange(keyword) {
	            this.keyword = keyword;
	        }
	    },
	    events: {
	        toShowManger: function toShowManger() {
	            this.showManager = true;
	        },
	        toHideManager: function toHideManager() {
	            this.showManager = false;
	        }
	    },
	    components: {
	        'slideload': __webpack_require__(33),
	        'menu': __webpack_require__(348),
	        'navigationbar': __webpack_require__(349),
	        'top-search': __webpack_require__(47),
	        'search-manager': __webpack_require__(82)
	    },
	    route: {
	        deactivate: function deactivate() {
	            console.log('home:route:deactivate');
	            this.showManager = false;
	            this.$broadcast('cancelScroll');
	        },
	        data: function data() {
	            console.log('home:route:activate');
	            document.title = '淘闲置';
	
	            this.$els.manager.style.display = 'none';
	            this.cateid = this.$route.params.cateid || null;
	            this.$broadcast('startScroll');
	            this.$broadcast('getInformation');
	        }
	    }
	};

/***/ },

/***/ 122:
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	    props: ['menuList', 'cateid', 'isShowMenu'],
	    methods: {
	        onNavClick: function onNavClick(cateid) {
	            this.isShowMenu = false;
	            this.$dispatch('change', cateid);
	        }
	    }
	};

/***/ },

/***/ 123:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var iScroll = __webpack_require__(244),
	    vTouch = __webpack_require__(100),
	    leStatic = __webpack_require__(19);
	module.exports = {
	    props: ['menuList', 'cateid', 'isShowMenu'],
	    ready: function ready() {
	        this.scroll = new iScroll(this.$els.scroll, {
	            scrollX: true,
	            snap: true
	        });
	    },
	    watch: {
	        "cateid": function cateid() {
	            var domActive = document.querySelector('.home-nav-scroll .active');
	            if (domActive) {
	                this.scroll.scrollToElement(domActive, null, null, true);
	            }
	        }
	    },
	    methods: {
	        onNavTap: function onNavTap(index, cateid) {
	            leStatic('MONITOR-TAB');
	            this.$dispatch('change', cateid);
	        },
	        onShowMenuClick: function onShowMenuClick() {
	            this.isShowMenu = true;
	        }
	    }
	};

/***/ },

/***/ 187:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "div,form,html,li,p,span,ul{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.top-action{position:fixed;top:0;z-index:1000;width:100%}.info-msg{padding-top:5.33333333rem}", "", {"version":3,"sources":["/./src/components/Home/Home.vue"],"names":[],"mappings":"AAAA,2BAA2B,yBAAyB,sBAAsB,qBAAqB,gBAAgB,CAAC,YAAY,eAAe,MAAM,aAAa,UAAU,CAAC,UAAU,yBAAyB,CAAC","file":"Home.vue","sourcesContent":["html,div,p,ul,li,form,span{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.top-action{position:fixed;top:0;z-index:1000;width:100%}.info-msg{padding-top:5.33333333rem}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },

/***/ 188:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "div,form,html,li,p,span,ul{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.menu{z-index:1500;height:33.54666667rem}.menu,.menu-all{background-color:#fff;width:100%}.menu-all{display:block;height:2.32rem;text-align:center;font-size:.74666667rem;font-weight:700;color:#292d33;border-bottom:.02666667rem solid #ebedf2;line-height:2.32rem;position:relative}.all-span{border-bottom:.10666667rem solid #e8ebf0;border-left:.10666667rem solid #e8ebf0;width:.45333333rem;height:.45333333rem;display:inline-block;-webkit-transform:rotate(135deg);transform:rotate(135deg);position:absolute;bottom:.88rem;right:1.06666667rem}.menu-list{list-style:none;background-color:#f1f2f6;height:26.66666667rem;overflow:hidden;margin:0;text-align:center;padding:.29333333rem 0}.menu-list li{display:inline-block;margin:.24rem .21333333rem}.menu-list a{display:inline-block;width:5.78666667rem;height:2.56rem;padding:.56rem 0;text-align:center;background-color:#fff;border:1px solid #eaebeb;border-radius:.10666667rem;color:#333}.menu-list a.active{color:#ea7073;border-color:#ea7073}.menu-keyword{display:block;height:1.33333333rem;margin:0 .53333333rem;font-size:.74666667rem;line-height:1.33333333rem}.menu-keyinfo{display:inline-block;height:1.22666667rem;margin:0 .26666667rem;font-size:.58666667rem;line-height:1.22666667rem}@-webkit-keyframes slideFromTop{0%{-webkit-transform:translateY(-100%);transform:translateY(-100%)}}@keyframes slideFromTop{0%{-webkit-transform:translateY(-100%);transform:translateY(-100%)}}.menu-side-enter{-webkit-animation:slideFromTop .2s forwards ease-in-out;animation:slideFromTop .2s forwards ease-in-out}", "", {"version":3,"sources":["/./src/components/Home/Menu/Menu.vue"],"names":[],"mappings":"AAAA,2BAA2B,yBAAyB,sBAAsB,qBAAqB,gBAAgB,CAAC,MAAM,aAAa,AAAiC,qBAAqB,CAAC,gBAAvD,sBAAsB,UAAW,CAAqP,AAA/N,UAAU,cAAc,AAAW,eAAe,kBAAkB,uBAAuB,gBAAiB,cAAc,yCAAyC,AAAsB,oBAAoB,iBAAiB,CAAC,UAAU,yCAAyC,uCAAuC,mBAAmB,oBAAoB,qBAAqB,iCAAiC,yBAAyB,kBAAkB,cAAc,mBAAmB,CAAC,WAAW,gBAAgB,yBAAyB,sBAAsB,gBAAgB,SAAS,kBAAkB,sBAAsB,CAAC,cAAc,qBAAqB,0BAA0B,CAAC,aAAa,qBAAqB,oBAAoB,eAAe,iBAAiB,kBAAkB,sBAAsB,yBAAyB,2BAA2B,UAAU,CAAC,oBAAoB,cAAc,oBAAoB,CAAC,cAAc,cAAc,qBAAqB,sBAAsB,uBAAuB,yBAAyB,CAAC,cAAc,qBAAqB,qBAAqB,sBAAsB,uBAAuB,yBAAyB,CAAC,gCAAgC,GAAK,oCAAoC,2BAA2B,CAAC,CAAC,wBAAwB,GAAK,oCAAoC,2BAA2B,CAAC,CAAC,iBAAiB,wDAA0D,+CAAiD,CAAC","file":"Menu.vue","sourcesContent":["html,div,p,ul,li,form,span{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.menu{z-index:1500;background-color:#fff;width:100%;height:33.54666667rem}.menu-all{display:block;width:100%;height:2.32rem;text-align:center;font-size:.74666667rem;font-weight:bold;color:#292d33;border-bottom:.02666667rem solid #ebedf2;background-color:#fff;line-height:2.32rem;position:relative}.all-span{border-bottom:.10666667rem solid #e8ebf0;border-left:.10666667rem solid #e8ebf0;width:.45333333rem;height:.45333333rem;display:inline-block;-webkit-transform:rotate(135deg);transform:rotate(135deg);position:absolute;bottom:.88rem;right:1.06666667rem}.menu-list{list-style:none;background-color:#f1f2f6;height:26.66666667rem;overflow:hidden;margin:0;text-align:center;padding:.29333333rem 0}.menu-list li{display:inline-block;margin:.24rem .21333333rem}.menu-list a{display:inline-block;width:5.78666667rem;height:2.56rem;padding:.56rem 0;text-align:center;background-color:#fff;border:1px solid #eaebeb;border-radius:.10666667rem;color:#333}.menu-list a.active{color:#ea7073;border-color:#ea7073}.menu-keyword{display:block;height:1.33333333rem;margin:0 .53333333rem;font-size:.74666667rem;line-height:1.33333333rem}.menu-keyinfo{display:inline-block;height:1.22666667rem;margin:0 .26666667rem;font-size:.58666667rem;line-height:1.22666667rem}@-webkit-keyframes slideFromTop{from{-webkit-transform:translateY(-100%);transform:translateY(-100%)}}@keyframes slideFromTop{from{-webkit-transform:translateY(-100%);transform:translateY(-100%)}}.menu-side-enter{-webkit-animation:slideFromTop 200ms forwards ease-in-out;animation:slideFromTop 200ms forwards ease-in-out}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },

/***/ 189:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "div,form,html,li,p,span,ul{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}::-webkit-scrollbar{display:none}.home-nav{color:#292d33;font-size:.69333333rem;border-bottom:1px solid #e8ebf0;background-color:#fff;position:relative;padding:0 .42666667rem}.home-nav-scroll{padding:.42666667rem 0;box-sizing:border-box;overflow:hidden}.home-nav .down{width:2.61333333rem;line-height:2.32rem;text-align:center;position:absolute;right:0;top:0;bottom:0;background:#fff}.home-nav .down:before{border-left:1px solid #e8ebf0;height:.53333333rem;content:\"\";position:absolute;left:0;top:.88rem}.home-nav .down:after{border-bottom:.10666667rem solid #e8ebf0;border-left:.10666667rem solid #e8ebf0;display:inline-block;width:.42666667rem;height:.42666667rem;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);content:\"\";margin-bottom:.10666667rem}.home-nav-list{list-style:none;margin:0;padding:0;white-space:nowrap;width:34.66666667rem}.home-nav li{margin:0 .10666667rem;display:inline-block}.home-nav li a{font-size:.69333333rem;background-color:#fff;border:1px solid transparent;border-radius:.8rem;display:block;padding:0 .74666667rem;height:1.38666667rem;line-height:1.38666667rem;text-align:center;text-decoration:none}.home-nav li a.active{border-color:#f0f2f5;color:#e84345}", "", {"version":3,"sources":["/./src/components/Home/NavigationBar/NavigationBar.vue"],"names":[],"mappings":"AAAA,2BAA2B,yBAAyB,sBAAsB,qBAAqB,gBAAgB,CAAC,oBAAoB,YAAY,CAAC,UAAU,cAAc,uBAAuB,gCAAgC,sBAAsB,kBAAkB,sBAAsB,CAAC,iBAAiB,uBAAuB,sBAAsB,eAAe,CAAC,gBAAgB,oBAAoB,oBAAoB,kBAAkB,kBAAkB,QAAQ,MAAM,SAAS,eAAe,CAAC,uBAAuB,8BAA8B,oBAAoB,WAAW,kBAAkB,OAAO,UAAU,CAAC,sBAAsB,yCAAyC,uCAAuC,qBAAqB,mBAAmB,oBAAoB,iCAAiC,yBAAyB,WAAW,0BAA0B,CAAC,eAAe,gBAAgB,SAAS,UAAU,mBAAmB,oBAAoB,CAAC,aAAa,sBAAsB,oBAAoB,CAAC,eAAe,uBAAuB,sBAAsB,6BAA6B,oBAAoB,cAAc,uBAAuB,qBAAqB,0BAA0B,kBAAkB,oBAAoB,CAAC,sBAAsB,qBAAqB,aAAa,CAAC","file":"NavigationBar.vue","sourcesContent":["html,div,p,ul,li,form,span{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}::-webkit-scrollbar{display:none}.home-nav{color:#292D33;font-size:.69333333rem;border-bottom:1px solid #E8EBF0;background-color:#fff;position:relative;padding:0 .42666667rem}.home-nav-scroll{padding:.42666667rem 0;box-sizing:border-box;overflow:hidden}.home-nav .down{width:2.61333333rem;line-height:2.32rem;text-align:center;position:absolute;right:0;top:0;bottom:0;background:#fff}.home-nav .down:before{border-left:1px solid #e8ebf0;height:.53333333rem;content:'';position:absolute;left:0;top:.88rem}.home-nav .down:after{border-bottom:.10666667rem solid #E8EBF0;border-left:.10666667rem solid #E8EBF0;display:inline-block;width:.42666667rem;height:.42666667rem;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);content:'';margin-bottom:.10666667rem}.home-nav-list{list-style:none;margin:0;padding:0;white-space:nowrap;width:34.66666667rem}.home-nav li{margin:0 .10666667rem;display:inline-block}.home-nav li a{font-size:.69333333rem;background-color:#fff;border:1px solid transparent;border-radius:.8rem;display:block;padding:0 .74666667rem;height:1.38666667rem;line-height:1.38666667rem;text-align:center;text-decoration:none}.home-nav li a.active{border-color:#F0F2F5;color:#E84345}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },

/***/ 222:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(187);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js!../../../node_modules/less-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Home.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js!../../../node_modules/less-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Home.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 223:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(188);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter.js!../../../../node_modules/less-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Menu.vue", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter.js!../../../../node_modules/less-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Menu.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 224:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(189);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter.js!../../../../node_modules/less-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./NavigationBar.vue", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter.js!../../../../node_modules/less-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./NavigationBar.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 244:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*! iScroll v5.2.0 ~ (c) 2008-2016 Matteo Spinelli ~ http://cubiq.org/license */
	(function (window, document, Math) {
	var rAF = window.requestAnimationFrame	||
		window.webkitRequestAnimationFrame	||
		window.mozRequestAnimationFrame		||
		window.oRequestAnimationFrame		||
		window.msRequestAnimationFrame		||
		function (callback) { window.setTimeout(callback, 1000 / 60); };
	
	var utils = (function () {
		var me = {};
	
		var _elementStyle = document.createElement('div').style;
		var _vendor = (function () {
			var vendors = ['t', 'webkitT', 'MozT', 'msT', 'OT'],
				transform,
				i = 0,
				l = vendors.length;
	
			for ( ; i < l; i++ ) {
				transform = vendors[i] + 'ransform';
				if ( transform in _elementStyle ) return vendors[i].substr(0, vendors[i].length-1);
			}
	
			return false;
		})();
	
		function _prefixStyle (style) {
			if ( _vendor === false ) return false;
			if ( _vendor === '' ) return style;
			return _vendor + style.charAt(0).toUpperCase() + style.substr(1);
		}
	
		me.getTime = Date.now || function getTime () { return new Date().getTime(); };
	
		me.extend = function (target, obj) {
			for ( var i in obj ) {
				target[i] = obj[i];
			}
		};
	
		me.addEvent = function (el, type, fn, capture) {
			el.addEventListener(type, fn, !!capture);
		};
	
		me.removeEvent = function (el, type, fn, capture) {
			el.removeEventListener(type, fn, !!capture);
		};
	
		me.prefixPointerEvent = function (pointerEvent) {
			return window.MSPointerEvent ?
				'MSPointer' + pointerEvent.charAt(7).toUpperCase() + pointerEvent.substr(8):
				pointerEvent;
		};
	
		me.momentum = function (current, start, time, lowerMargin, wrapperSize, deceleration) {
			var distance = current - start,
				speed = Math.abs(distance) / time,
				destination,
				duration;
	
			deceleration = deceleration === undefined ? 0.0006 : deceleration;
	
			destination = current + ( speed * speed ) / ( 2 * deceleration ) * ( distance < 0 ? -1 : 1 );
			duration = speed / deceleration;
	
			if ( destination < lowerMargin ) {
				destination = wrapperSize ? lowerMargin - ( wrapperSize / 2.5 * ( speed / 8 ) ) : lowerMargin;
				distance = Math.abs(destination - current);
				duration = distance / speed;
			} else if ( destination > 0 ) {
				destination = wrapperSize ? wrapperSize / 2.5 * ( speed / 8 ) : 0;
				distance = Math.abs(current) + destination;
				duration = distance / speed;
			}
	
			return {
				destination: Math.round(destination),
				duration: duration
			};
		};
	
		var _transform = _prefixStyle('transform');
	
		me.extend(me, {
			hasTransform: _transform !== false,
			hasPerspective: _prefixStyle('perspective') in _elementStyle,
			hasTouch: 'ontouchstart' in window,
			hasPointer: !!(window.PointerEvent || window.MSPointerEvent), // IE10 is prefixed
			hasTransition: _prefixStyle('transition') in _elementStyle
		});
	
		/*
		This should find all Android browsers lower than build 535.19 (both stock browser and webview)
		- galaxy S2 is ok
	    - 2.3.6 : `AppleWebKit/533.1 (KHTML, like Gecko) Version/4.0 Mobile Safari/533.1`
	    - 4.0.4 : `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
	   - galaxy S3 is badAndroid (stock brower, webview)
	     `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
	   - galaxy S4 is badAndroid (stock brower, webview)
	     `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
	   - galaxy S5 is OK
	     `AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Mobile Safari/537.36 (Chrome/)`
	   - galaxy S6 is OK
	     `AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Mobile Safari/537.36 (Chrome/)`
	  */
		me.isBadAndroid = (function() {
			var appVersion = window.navigator.appVersion;
			// Android browser is not a chrome browser.
			if (/Android/.test(appVersion) && !(/Chrome\/\d/.test(appVersion))) {
				var safariVersion = appVersion.match(/Safari\/(\d+.\d)/);
				if(safariVersion && typeof safariVersion === "object" && safariVersion.length >= 2) {
					return parseFloat(safariVersion[1]) < 535.19;
				} else {
					return true;
				}
			} else {
				return false;
			}
		})();
	
		me.extend(me.style = {}, {
			transform: _transform,
			transitionTimingFunction: _prefixStyle('transitionTimingFunction'),
			transitionDuration: _prefixStyle('transitionDuration'),
			transitionDelay: _prefixStyle('transitionDelay'),
			transformOrigin: _prefixStyle('transformOrigin')
		});
	
		me.hasClass = function (e, c) {
			var re = new RegExp("(^|\\s)" + c + "(\\s|$)");
			return re.test(e.className);
		};
	
		me.addClass = function (e, c) {
			if ( me.hasClass(e, c) ) {
				return;
			}
	
			var newclass = e.className.split(' ');
			newclass.push(c);
			e.className = newclass.join(' ');
		};
	
		me.removeClass = function (e, c) {
			if ( !me.hasClass(e, c) ) {
				return;
			}
	
			var re = new RegExp("(^|\\s)" + c + "(\\s|$)", 'g');
			e.className = e.className.replace(re, ' ');
		};
	
		me.offset = function (el) {
			var left = -el.offsetLeft,
				top = -el.offsetTop;
	
			// jshint -W084
			while (el = el.offsetParent) {
				left -= el.offsetLeft;
				top -= el.offsetTop;
			}
			// jshint +W084
	
			return {
				left: left,
				top: top
			};
		};
	
		me.preventDefaultException = function (el, exceptions) {
			for ( var i in exceptions ) {
				if ( exceptions[i].test(el[i]) ) {
					return true;
				}
			}
	
			return false;
		};
	
		me.extend(me.eventType = {}, {
			touchstart: 1,
			touchmove: 1,
			touchend: 1,
	
			mousedown: 2,
			mousemove: 2,
			mouseup: 2,
	
			pointerdown: 3,
			pointermove: 3,
			pointerup: 3,
	
			MSPointerDown: 3,
			MSPointerMove: 3,
			MSPointerUp: 3
		});
	
		me.extend(me.ease = {}, {
			quadratic: {
				style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
				fn: function (k) {
					return k * ( 2 - k );
				}
			},
			circular: {
				style: 'cubic-bezier(0.1, 0.57, 0.1, 1)',	// Not properly "circular" but this looks better, it should be (0.075, 0.82, 0.165, 1)
				fn: function (k) {
					return Math.sqrt( 1 - ( --k * k ) );
				}
			},
			back: {
				style: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
				fn: function (k) {
					var b = 4;
					return ( k = k - 1 ) * k * ( ( b + 1 ) * k + b ) + 1;
				}
			},
			bounce: {
				style: '',
				fn: function (k) {
					if ( ( k /= 1 ) < ( 1 / 2.75 ) ) {
						return 7.5625 * k * k;
					} else if ( k < ( 2 / 2.75 ) ) {
						return 7.5625 * ( k -= ( 1.5 / 2.75 ) ) * k + 0.75;
					} else if ( k < ( 2.5 / 2.75 ) ) {
						return 7.5625 * ( k -= ( 2.25 / 2.75 ) ) * k + 0.9375;
					} else {
						return 7.5625 * ( k -= ( 2.625 / 2.75 ) ) * k + 0.984375;
					}
				}
			},
			elastic: {
				style: '',
				fn: function (k) {
					var f = 0.22,
						e = 0.4;
	
					if ( k === 0 ) { return 0; }
					if ( k == 1 ) { return 1; }
	
					return ( e * Math.pow( 2, - 10 * k ) * Math.sin( ( k - f / 4 ) * ( 2 * Math.PI ) / f ) + 1 );
				}
			}
		});
	
		me.tap = function (e, eventName) {
			var ev = document.createEvent('Event');
			ev.initEvent(eventName, true, true);
			ev.pageX = e.pageX;
			ev.pageY = e.pageY;
			e.target.dispatchEvent(ev);
		};
	
		me.click = function (e) {
			var target = e.target,
				ev;
	
			if ( !(/(SELECT|INPUT|TEXTAREA)/i).test(target.tagName) ) {
				ev = document.createEvent('MouseEvents');
				ev.initMouseEvent('click', true, true, e.view, 1,
					target.screenX, target.screenY, target.clientX, target.clientY,
					e.ctrlKey, e.altKey, e.shiftKey, e.metaKey,
					0, null);
	
				ev._constructed = true;
				target.dispatchEvent(ev);
			}
		};
	
		return me;
	})();
	function IScroll (el, options) {
		this.wrapper = typeof el == 'string' ? document.querySelector(el) : el;
		this.scroller = this.wrapper.children[0];
		this.scrollerStyle = this.scroller.style;		// cache style for better performance
	
		this.options = {
	
			resizeScrollbars: true,
	
			mouseWheelSpeed: 20,
	
			snapThreshold: 0.334,
	
	// INSERT POINT: OPTIONS
			disablePointer : !utils.hasPointer,
			disableTouch : utils.hasPointer || !utils.hasTouch,
			disableMouse : utils.hasPointer || utils.hasTouch,
			startX: 0,
			startY: 0,
			scrollY: true,
			directionLockThreshold: 5,
			momentum: true,
	
			bounce: true,
			bounceTime: 600,
			bounceEasing: '',
	
			preventDefault: true,
			preventDefaultException: { tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT)$/ },
	
			HWCompositing: true,
			useTransition: true,
			useTransform: true,
			bindToWrapper: typeof window.onmousedown === "undefined"
		};
	
		for ( var i in options ) {
			this.options[i] = options[i];
		}
	
		// Normalize options
		this.translateZ = this.options.HWCompositing && utils.hasPerspective ? ' translateZ(0)' : '';
	
		this.options.useTransition = utils.hasTransition && this.options.useTransition;
		this.options.useTransform = utils.hasTransform && this.options.useTransform;
	
		this.options.eventPassthrough = this.options.eventPassthrough === true ? 'vertical' : this.options.eventPassthrough;
		this.options.preventDefault = !this.options.eventPassthrough && this.options.preventDefault;
	
		// If you want eventPassthrough I have to lock one of the axes
		this.options.scrollY = this.options.eventPassthrough == 'vertical' ? false : this.options.scrollY;
		this.options.scrollX = this.options.eventPassthrough == 'horizontal' ? false : this.options.scrollX;
	
		// With eventPassthrough we also need lockDirection mechanism
		this.options.freeScroll = this.options.freeScroll && !this.options.eventPassthrough;
		this.options.directionLockThreshold = this.options.eventPassthrough ? 0 : this.options.directionLockThreshold;
	
		this.options.bounceEasing = typeof this.options.bounceEasing == 'string' ? utils.ease[this.options.bounceEasing] || utils.ease.circular : this.options.bounceEasing;
	
		this.options.resizePolling = this.options.resizePolling === undefined ? 60 : this.options.resizePolling;
	
		if ( this.options.tap === true ) {
			this.options.tap = 'tap';
		}
	
		if ( this.options.shrinkScrollbars == 'scale' ) {
			this.options.useTransition = false;
		}
	
		this.options.invertWheelDirection = this.options.invertWheelDirection ? -1 : 1;
	
	// INSERT POINT: NORMALIZATION
	
		// Some defaults
		this.x = 0;
		this.y = 0;
		this.directionX = 0;
		this.directionY = 0;
		this._events = {};
	
	// INSERT POINT: DEFAULTS
	
		this._init();
		this.refresh();
	
		this.scrollTo(this.options.startX, this.options.startY);
		this.enable();
	}
	
	IScroll.prototype = {
		version: '5.2.0',
	
		_init: function () {
			this._initEvents();
	
			if ( this.options.scrollbars || this.options.indicators ) {
				this._initIndicators();
			}
	
			if ( this.options.mouseWheel ) {
				this._initWheel();
			}
	
			if ( this.options.snap ) {
				this._initSnap();
			}
	
			if ( this.options.keyBindings ) {
				this._initKeys();
			}
	
	// INSERT POINT: _init
	
		},
	
		destroy: function () {
			this._initEvents(true);
			clearTimeout(this.resizeTimeout);
	 		this.resizeTimeout = null;
			this._execEvent('destroy');
		},
	
		_transitionEnd: function (e) {
			if ( e.target != this.scroller || !this.isInTransition ) {
				return;
			}
	
			this._transitionTime();
			if ( !this.resetPosition(this.options.bounceTime) ) {
				this.isInTransition = false;
				this._execEvent('scrollEnd');
			}
		},
	
		_start: function (e) {
			// React to left mouse button only
			if ( utils.eventType[e.type] != 1 ) {
			  // for button property
			  // http://unixpapa.com/js/mouse.html
			  var button;
		    if (!e.which) {
		      /* IE case */
		      button = (e.button < 2) ? 0 :
		               ((e.button == 4) ? 1 : 2);
		    } else {
		      /* All others */
		      button = e.button;
		    }
				if ( button !== 0 ) {
					return;
				}
			}
	
			if ( !this.enabled || (this.initiated && utils.eventType[e.type] !== this.initiated) ) {
				return;
			}
	
			if ( this.options.preventDefault && !utils.isBadAndroid && !utils.preventDefaultException(e.target, this.options.preventDefaultException) ) {
				e.preventDefault();
			}
	
			var point = e.touches ? e.touches[0] : e,
				pos;
	
			this.initiated	= utils.eventType[e.type];
			this.moved		= false;
			this.distX		= 0;
			this.distY		= 0;
			this.directionX = 0;
			this.directionY = 0;
			this.directionLocked = 0;
	
			this.startTime = utils.getTime();
	
			if ( this.options.useTransition && this.isInTransition ) {
				this._transitionTime();
				this.isInTransition = false;
				pos = this.getComputedPosition();
				this._translate(Math.round(pos.x), Math.round(pos.y));
				this._execEvent('scrollEnd');
			} else if ( !this.options.useTransition && this.isAnimating ) {
				this.isAnimating = false;
				this._execEvent('scrollEnd');
			}
	
			this.startX    = this.x;
			this.startY    = this.y;
			this.absStartX = this.x;
			this.absStartY = this.y;
			this.pointX    = point.pageX;
			this.pointY    = point.pageY;
	
			this._execEvent('beforeScrollStart');
		},
	
		_move: function (e) {
			if ( !this.enabled || utils.eventType[e.type] !== this.initiated ) {
				return;
			}
	
			if ( this.options.preventDefault ) {	// increases performance on Android? TODO: check!
				e.preventDefault();
			}
	
			var point		= e.touches ? e.touches[0] : e,
				deltaX		= point.pageX - this.pointX,
				deltaY		= point.pageY - this.pointY,
				timestamp	= utils.getTime(),
				newX, newY,
				absDistX, absDistY;
	
			this.pointX		= point.pageX;
			this.pointY		= point.pageY;
	
			this.distX		+= deltaX;
			this.distY		+= deltaY;
			absDistX		= Math.abs(this.distX);
			absDistY		= Math.abs(this.distY);
	
			// We need to move at least 10 pixels for the scrolling to initiate
			if ( timestamp - this.endTime > 300 && (absDistX < 10 && absDistY < 10) ) {
				return;
			}
	
			// If you are scrolling in one direction lock the other
			if ( !this.directionLocked && !this.options.freeScroll ) {
				if ( absDistX > absDistY + this.options.directionLockThreshold ) {
					this.directionLocked = 'h';		// lock horizontally
				} else if ( absDistY >= absDistX + this.options.directionLockThreshold ) {
					this.directionLocked = 'v';		// lock vertically
				} else {
					this.directionLocked = 'n';		// no lock
				}
			}
	
			if ( this.directionLocked == 'h' ) {
				if ( this.options.eventPassthrough == 'vertical' ) {
					e.preventDefault();
				} else if ( this.options.eventPassthrough == 'horizontal' ) {
					this.initiated = false;
					return;
				}
	
				deltaY = 0;
			} else if ( this.directionLocked == 'v' ) {
				if ( this.options.eventPassthrough == 'horizontal' ) {
					e.preventDefault();
				} else if ( this.options.eventPassthrough == 'vertical' ) {
					this.initiated = false;
					return;
				}
	
				deltaX = 0;
			}
	
			deltaX = this.hasHorizontalScroll ? deltaX : 0;
			deltaY = this.hasVerticalScroll ? deltaY : 0;
	
			newX = this.x + deltaX;
			newY = this.y + deltaY;
	
			// Slow down if outside of the boundaries
			if ( newX > 0 || newX < this.maxScrollX ) {
				newX = this.options.bounce ? this.x + deltaX / 3 : newX > 0 ? 0 : this.maxScrollX;
			}
			if ( newY > 0 || newY < this.maxScrollY ) {
				newY = this.options.bounce ? this.y + deltaY / 3 : newY > 0 ? 0 : this.maxScrollY;
			}
	
			this.directionX = deltaX > 0 ? -1 : deltaX < 0 ? 1 : 0;
			this.directionY = deltaY > 0 ? -1 : deltaY < 0 ? 1 : 0;
	
			if ( !this.moved ) {
				this._execEvent('scrollStart');
			}
	
			this.moved = true;
	
			this._translate(newX, newY);
	
	/* REPLACE START: _move */
	
			if ( timestamp - this.startTime > 300 ) {
				this.startTime = timestamp;
				this.startX = this.x;
				this.startY = this.y;
			}
	
	/* REPLACE END: _move */
	
		},
	
		_end: function (e) {
			if ( !this.enabled || utils.eventType[e.type] !== this.initiated ) {
				return;
			}
	
			if ( this.options.preventDefault && !utils.preventDefaultException(e.target, this.options.preventDefaultException) ) {
				e.preventDefault();
			}
	
			var point = e.changedTouches ? e.changedTouches[0] : e,
				momentumX,
				momentumY,
				duration = utils.getTime() - this.startTime,
				newX = Math.round(this.x),
				newY = Math.round(this.y),
				distanceX = Math.abs(newX - this.startX),
				distanceY = Math.abs(newY - this.startY),
				time = 0,
				easing = '';
	
			this.isInTransition = 0;
			this.initiated = 0;
			this.endTime = utils.getTime();
	
			// reset if we are outside of the boundaries
			if ( this.resetPosition(this.options.bounceTime) ) {
				return;
			}
	
			this.scrollTo(newX, newY);	// ensures that the last position is rounded
	
			// we scrolled less than 10 pixels
			if ( !this.moved ) {
				if ( this.options.tap ) {
					utils.tap(e, this.options.tap);
				}
	
				if ( this.options.click ) {
					utils.click(e);
				}
	
				this._execEvent('scrollCancel');
				return;
			}
	
			if ( this._events.flick && duration < 200 && distanceX < 100 && distanceY < 100 ) {
				this._execEvent('flick');
				return;
			}
	
			// start momentum animation if needed
			if ( this.options.momentum && duration < 300 ) {
				momentumX = this.hasHorizontalScroll ? utils.momentum(this.x, this.startX, duration, this.maxScrollX, this.options.bounce ? this.wrapperWidth : 0, this.options.deceleration) : { destination: newX, duration: 0 };
				momentumY = this.hasVerticalScroll ? utils.momentum(this.y, this.startY, duration, this.maxScrollY, this.options.bounce ? this.wrapperHeight : 0, this.options.deceleration) : { destination: newY, duration: 0 };
				newX = momentumX.destination;
				newY = momentumY.destination;
				time = Math.max(momentumX.duration, momentumY.duration);
				this.isInTransition = 1;
			}
	
	
			if ( this.options.snap ) {
				var snap = this._nearestSnap(newX, newY);
				this.currentPage = snap;
				time = this.options.snapSpeed || Math.max(
						Math.max(
							Math.min(Math.abs(newX - snap.x), 1000),
							Math.min(Math.abs(newY - snap.y), 1000)
						), 300);
				newX = snap.x;
				newY = snap.y;
	
				this.directionX = 0;
				this.directionY = 0;
				easing = this.options.bounceEasing;
			}
	
	// INSERT POINT: _end
	
			if ( newX != this.x || newY != this.y ) {
				// change easing function when scroller goes out of the boundaries
				if ( newX > 0 || newX < this.maxScrollX || newY > 0 || newY < this.maxScrollY ) {
					easing = utils.ease.quadratic;
				}
	
				this.scrollTo(newX, newY, time, easing);
				return;
			}
	
			this._execEvent('scrollEnd');
		},
	
		_resize: function () {
			var that = this;
	
			clearTimeout(this.resizeTimeout);
	
			this.resizeTimeout = setTimeout(function () {
				that.refresh();
			}, this.options.resizePolling);
		},
	
		resetPosition: function (time) {
			var x = this.x,
				y = this.y;
	
			time = time || 0;
	
			if ( !this.hasHorizontalScroll || this.x > 0 ) {
				x = 0;
			} else if ( this.x < this.maxScrollX ) {
				x = this.maxScrollX;
			}
	
			if ( !this.hasVerticalScroll || this.y > 0 ) {
				y = 0;
			} else if ( this.y < this.maxScrollY ) {
				y = this.maxScrollY;
			}
	
			if ( x == this.x && y == this.y ) {
				return false;
			}
	
			this.scrollTo(x, y, time, this.options.bounceEasing);
	
			return true;
		},
	
		disable: function () {
			this.enabled = false;
		},
	
		enable: function () {
			this.enabled = true;
		},
	
		refresh: function () {
			var rf = this.wrapper.offsetHeight;		// Force reflow
	
			this.wrapperWidth	= this.wrapper.clientWidth;
			this.wrapperHeight	= this.wrapper.clientHeight;
	
	/* REPLACE START: refresh */
	
			this.scrollerWidth	= this.scroller.offsetWidth;
			this.scrollerHeight	= this.scroller.offsetHeight;
	
			this.maxScrollX		= this.wrapperWidth - this.scrollerWidth;
			this.maxScrollY		= this.wrapperHeight - this.scrollerHeight;
	
	/* REPLACE END: refresh */
	
			this.hasHorizontalScroll	= this.options.scrollX && this.maxScrollX < 0;
			this.hasVerticalScroll		= this.options.scrollY && this.maxScrollY < 0;
	
			if ( !this.hasHorizontalScroll ) {
				this.maxScrollX = 0;
				this.scrollerWidth = this.wrapperWidth;
			}
	
			if ( !this.hasVerticalScroll ) {
				this.maxScrollY = 0;
				this.scrollerHeight = this.wrapperHeight;
			}
	
			this.endTime = 0;
			this.directionX = 0;
			this.directionY = 0;
	
			this.wrapperOffset = utils.offset(this.wrapper);
	
			this._execEvent('refresh');
	
			this.resetPosition();
	
	// INSERT POINT: _refresh
	
		},
	
		on: function (type, fn) {
			if ( !this._events[type] ) {
				this._events[type] = [];
			}
	
			this._events[type].push(fn);
		},
	
		off: function (type, fn) {
			if ( !this._events[type] ) {
				return;
			}
	
			var index = this._events[type].indexOf(fn);
	
			if ( index > -1 ) {
				this._events[type].splice(index, 1);
			}
		},
	
		_execEvent: function (type) {
			if ( !this._events[type] ) {
				return;
			}
	
			var i = 0,
				l = this._events[type].length;
	
			if ( !l ) {
				return;
			}
	
			for ( ; i < l; i++ ) {
				this._events[type][i].apply(this, [].slice.call(arguments, 1));
			}
		},
	
		scrollBy: function (x, y, time, easing) {
			x = this.x + x;
			y = this.y + y;
			time = time || 0;
	
			this.scrollTo(x, y, time, easing);
		},
	
		scrollTo: function (x, y, time, easing) {
			easing = easing || utils.ease.circular;
	
			this.isInTransition = this.options.useTransition && time > 0;
			var transitionType = this.options.useTransition && easing.style;
			if ( !time || transitionType ) {
					if(transitionType) {
						this._transitionTimingFunction(easing.style);
						this._transitionTime(time);
					}
				this._translate(x, y);
			} else {
				this._animate(x, y, time, easing.fn);
			}
		},
	
		scrollToElement: function (el, time, offsetX, offsetY, easing) {
			el = el.nodeType ? el : this.scroller.querySelector(el);
	
			if ( !el ) {
				return;
			}
	
			var pos = utils.offset(el);
	
			pos.left -= this.wrapperOffset.left;
			pos.top  -= this.wrapperOffset.top;
	
			// if offsetX/Y are true we center the element to the screen
			if ( offsetX === true ) {
				offsetX = Math.round(el.offsetWidth / 2 - this.wrapper.offsetWidth / 2);
			}
			if ( offsetY === true ) {
				offsetY = Math.round(el.offsetHeight / 2 - this.wrapper.offsetHeight / 2);
			}
	
			pos.left -= offsetX || 0;
			pos.top  -= offsetY || 0;
	
			pos.left = pos.left > 0 ? 0 : pos.left < this.maxScrollX ? this.maxScrollX : pos.left;
			pos.top  = pos.top  > 0 ? 0 : pos.top  < this.maxScrollY ? this.maxScrollY : pos.top;
	
			time = time === undefined || time === null || time === 'auto' ? Math.max(Math.abs(this.x-pos.left), Math.abs(this.y-pos.top)) : time;
	
			this.scrollTo(pos.left, pos.top, time, easing);
		},
	
		_transitionTime: function (time) {
			time = time || 0;
	
			var durationProp = utils.style.transitionDuration;
			this.scrollerStyle[durationProp] = time + 'ms';
	
			if ( !time && utils.isBadAndroid ) {
				this.scrollerStyle[durationProp] = '0.0001ms';
				// remove 0.0001ms
				var self = this;
				rAF(function() {
					if(self.scrollerStyle[durationProp] === '0.0001ms') {
						self.scrollerStyle[durationProp] = '0s';
					}
				});
			}
	
	
			if ( this.indicators ) {
				for ( var i = this.indicators.length; i--; ) {
					this.indicators[i].transitionTime(time);
				}
			}
	
	
	// INSERT POINT: _transitionTime
	
		},
	
		_transitionTimingFunction: function (easing) {
			this.scrollerStyle[utils.style.transitionTimingFunction] = easing;
	
	
			if ( this.indicators ) {
				for ( var i = this.indicators.length; i--; ) {
					this.indicators[i].transitionTimingFunction(easing);
				}
			}
	
	
	// INSERT POINT: _transitionTimingFunction
	
		},
	
		_translate: function (x, y) {
			if ( this.options.useTransform ) {
	
	/* REPLACE START: _translate */
	
				this.scrollerStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.translateZ;
	
	/* REPLACE END: _translate */
	
			} else {
				x = Math.round(x);
				y = Math.round(y);
				this.scrollerStyle.left = x + 'px';
				this.scrollerStyle.top = y + 'px';
			}
	
			this.x = x;
			this.y = y;
	
	
		if ( this.indicators ) {
			for ( var i = this.indicators.length; i--; ) {
				this.indicators[i].updatePosition();
			}
		}
	
	
	// INSERT POINT: _translate
	
		},
	
		_initEvents: function (remove) {
			var eventType = remove ? utils.removeEvent : utils.addEvent,
				target = this.options.bindToWrapper ? this.wrapper : window;
	
			eventType(window, 'orientationchange', this);
			eventType(window, 'resize', this);
	
			if ( this.options.click ) {
				eventType(this.wrapper, 'click', this, true);
			}
	
			if ( !this.options.disableMouse ) {
				eventType(this.wrapper, 'mousedown', this);
				eventType(target, 'mousemove', this);
				eventType(target, 'mousecancel', this);
				eventType(target, 'mouseup', this);
			}
	
			if ( utils.hasPointer && !this.options.disablePointer ) {
				eventType(this.wrapper, utils.prefixPointerEvent('pointerdown'), this);
				eventType(target, utils.prefixPointerEvent('pointermove'), this);
				eventType(target, utils.prefixPointerEvent('pointercancel'), this);
				eventType(target, utils.prefixPointerEvent('pointerup'), this);
			}
	
			if ( utils.hasTouch && !this.options.disableTouch ) {
				eventType(this.wrapper, 'touchstart', this);
				eventType(target, 'touchmove', this);
				eventType(target, 'touchcancel', this);
				eventType(target, 'touchend', this);
			}
	
			eventType(this.scroller, 'transitionend', this);
			eventType(this.scroller, 'webkitTransitionEnd', this);
			eventType(this.scroller, 'oTransitionEnd', this);
			eventType(this.scroller, 'MSTransitionEnd', this);
		},
	
		getComputedPosition: function () {
			var matrix = window.getComputedStyle(this.scroller, null),
				x, y;
	
			if ( this.options.useTransform ) {
				matrix = matrix[utils.style.transform].split(')')[0].split(', ');
				x = +(matrix[12] || matrix[4]);
				y = +(matrix[13] || matrix[5]);
			} else {
				x = +matrix.left.replace(/[^-\d.]/g, '');
				y = +matrix.top.replace(/[^-\d.]/g, '');
			}
	
			return { x: x, y: y };
		},
		_initIndicators: function () {
			var interactive = this.options.interactiveScrollbars,
				customStyle = typeof this.options.scrollbars != 'string',
				indicators = [],
				indicator;
	
			var that = this;
	
			this.indicators = [];
	
			if ( this.options.scrollbars ) {
				// Vertical scrollbar
				if ( this.options.scrollY ) {
					indicator = {
						el: createDefaultScrollbar('v', interactive, this.options.scrollbars),
						interactive: interactive,
						defaultScrollbars: true,
						customStyle: customStyle,
						resize: this.options.resizeScrollbars,
						shrink: this.options.shrinkScrollbars,
						fade: this.options.fadeScrollbars,
						listenX: false
					};
	
					this.wrapper.appendChild(indicator.el);
					indicators.push(indicator);
				}
	
				// Horizontal scrollbar
				if ( this.options.scrollX ) {
					indicator = {
						el: createDefaultScrollbar('h', interactive, this.options.scrollbars),
						interactive: interactive,
						defaultScrollbars: true,
						customStyle: customStyle,
						resize: this.options.resizeScrollbars,
						shrink: this.options.shrinkScrollbars,
						fade: this.options.fadeScrollbars,
						listenY: false
					};
	
					this.wrapper.appendChild(indicator.el);
					indicators.push(indicator);
				}
			}
	
			if ( this.options.indicators ) {
				// TODO: check concat compatibility
				indicators = indicators.concat(this.options.indicators);
			}
	
			for ( var i = indicators.length; i--; ) {
				this.indicators.push( new Indicator(this, indicators[i]) );
			}
	
			// TODO: check if we can use array.map (wide compatibility and performance issues)
			function _indicatorsMap (fn) {
				if (that.indicators) {
					for ( var i = that.indicators.length; i--; ) {
						fn.call(that.indicators[i]);
					}
				}
			}
	
			if ( this.options.fadeScrollbars ) {
				this.on('scrollEnd', function () {
					_indicatorsMap(function () {
						this.fade();
					});
				});
	
				this.on('scrollCancel', function () {
					_indicatorsMap(function () {
						this.fade();
					});
				});
	
				this.on('scrollStart', function () {
					_indicatorsMap(function () {
						this.fade(1);
					});
				});
	
				this.on('beforeScrollStart', function () {
					_indicatorsMap(function () {
						this.fade(1, true);
					});
				});
			}
	
	
			this.on('refresh', function () {
				_indicatorsMap(function () {
					this.refresh();
				});
			});
	
			this.on('destroy', function () {
				_indicatorsMap(function () {
					this.destroy();
				});
	
				delete this.indicators;
			});
		},
	
		_initWheel: function () {
			utils.addEvent(this.wrapper, 'wheel', this);
			utils.addEvent(this.wrapper, 'mousewheel', this);
			utils.addEvent(this.wrapper, 'DOMMouseScroll', this);
	
			this.on('destroy', function () {
				clearTimeout(this.wheelTimeout);
				this.wheelTimeout = null;
				utils.removeEvent(this.wrapper, 'wheel', this);
				utils.removeEvent(this.wrapper, 'mousewheel', this);
				utils.removeEvent(this.wrapper, 'DOMMouseScroll', this);
			});
		},
	
		_wheel: function (e) {
			if ( !this.enabled ) {
				return;
			}
	
			e.preventDefault();
	
			var wheelDeltaX, wheelDeltaY,
				newX, newY,
				that = this;
	
			if ( this.wheelTimeout === undefined ) {
				that._execEvent('scrollStart');
			}
	
			// Execute the scrollEnd event after 400ms the wheel stopped scrolling
			clearTimeout(this.wheelTimeout);
			this.wheelTimeout = setTimeout(function () {
				if(!that.options.snap) {
					that._execEvent('scrollEnd');
				}
				that.wheelTimeout = undefined;
			}, 400);
	
			if ( 'deltaX' in e ) {
				if (e.deltaMode === 1) {
					wheelDeltaX = -e.deltaX * this.options.mouseWheelSpeed;
					wheelDeltaY = -e.deltaY * this.options.mouseWheelSpeed;
				} else {
					wheelDeltaX = -e.deltaX;
					wheelDeltaY = -e.deltaY;
				}
			} else if ( 'wheelDeltaX' in e ) {
				wheelDeltaX = e.wheelDeltaX / 120 * this.options.mouseWheelSpeed;
				wheelDeltaY = e.wheelDeltaY / 120 * this.options.mouseWheelSpeed;
			} else if ( 'wheelDelta' in e ) {
				wheelDeltaX = wheelDeltaY = e.wheelDelta / 120 * this.options.mouseWheelSpeed;
			} else if ( 'detail' in e ) {
				wheelDeltaX = wheelDeltaY = -e.detail / 3 * this.options.mouseWheelSpeed;
			} else {
				return;
			}
	
			wheelDeltaX *= this.options.invertWheelDirection;
			wheelDeltaY *= this.options.invertWheelDirection;
	
			if ( !this.hasVerticalScroll ) {
				wheelDeltaX = wheelDeltaY;
				wheelDeltaY = 0;
			}
	
			if ( this.options.snap ) {
				newX = this.currentPage.pageX;
				newY = this.currentPage.pageY;
	
				if ( wheelDeltaX > 0 ) {
					newX--;
				} else if ( wheelDeltaX < 0 ) {
					newX++;
				}
	
				if ( wheelDeltaY > 0 ) {
					newY--;
				} else if ( wheelDeltaY < 0 ) {
					newY++;
				}
	
				this.goToPage(newX, newY);
	
				return;
			}
	
			newX = this.x + Math.round(this.hasHorizontalScroll ? wheelDeltaX : 0);
			newY = this.y + Math.round(this.hasVerticalScroll ? wheelDeltaY : 0);
	
			this.directionX = wheelDeltaX > 0 ? -1 : wheelDeltaX < 0 ? 1 : 0;
			this.directionY = wheelDeltaY > 0 ? -1 : wheelDeltaY < 0 ? 1 : 0;
	
			if ( newX > 0 ) {
				newX = 0;
			} else if ( newX < this.maxScrollX ) {
				newX = this.maxScrollX;
			}
	
			if ( newY > 0 ) {
				newY = 0;
			} else if ( newY < this.maxScrollY ) {
				newY = this.maxScrollY;
			}
	
			this.scrollTo(newX, newY, 0);
	
	// INSERT POINT: _wheel
		},
	
		_initSnap: function () {
			this.currentPage = {};
	
			if ( typeof this.options.snap == 'string' ) {
				this.options.snap = this.scroller.querySelectorAll(this.options.snap);
			}
	
			this.on('refresh', function () {
				var i = 0, l,
					m = 0, n,
					cx, cy,
					x = 0, y,
					stepX = this.options.snapStepX || this.wrapperWidth,
					stepY = this.options.snapStepY || this.wrapperHeight,
					el;
	
				this.pages = [];
	
				if ( !this.wrapperWidth || !this.wrapperHeight || !this.scrollerWidth || !this.scrollerHeight ) {
					return;
				}
	
				if ( this.options.snap === true ) {
					cx = Math.round( stepX / 2 );
					cy = Math.round( stepY / 2 );
	
					while ( x > -this.scrollerWidth ) {
						this.pages[i] = [];
						l = 0;
						y = 0;
	
						while ( y > -this.scrollerHeight ) {
							this.pages[i][l] = {
								x: Math.max(x, this.maxScrollX),
								y: Math.max(y, this.maxScrollY),
								width: stepX,
								height: stepY,
								cx: x - cx,
								cy: y - cy
							};
	
							y -= stepY;
							l++;
						}
	
						x -= stepX;
						i++;
					}
				} else {
					el = this.options.snap;
					l = el.length;
					n = -1;
	
					for ( ; i < l; i++ ) {
						if ( i === 0 || el[i].offsetLeft <= el[i-1].offsetLeft ) {
							m = 0;
							n++;
						}
	
						if ( !this.pages[m] ) {
							this.pages[m] = [];
						}
	
						x = Math.max(-el[i].offsetLeft, this.maxScrollX);
						y = Math.max(-el[i].offsetTop, this.maxScrollY);
						cx = x - Math.round(el[i].offsetWidth / 2);
						cy = y - Math.round(el[i].offsetHeight / 2);
	
						this.pages[m][n] = {
							x: x,
							y: y,
							width: el[i].offsetWidth,
							height: el[i].offsetHeight,
							cx: cx,
							cy: cy
						};
	
						if ( x > this.maxScrollX ) {
							m++;
						}
					}
				}
	
				this.goToPage(this.currentPage.pageX || 0, this.currentPage.pageY || 0, 0);
	
				// Update snap threshold if needed
				if ( this.options.snapThreshold % 1 === 0 ) {
					this.snapThresholdX = this.options.snapThreshold;
					this.snapThresholdY = this.options.snapThreshold;
				} else {
					this.snapThresholdX = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].width * this.options.snapThreshold);
					this.snapThresholdY = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].height * this.options.snapThreshold);
				}
			});
	
			this.on('flick', function () {
				var time = this.options.snapSpeed || Math.max(
						Math.max(
							Math.min(Math.abs(this.x - this.startX), 1000),
							Math.min(Math.abs(this.y - this.startY), 1000)
						), 300);
	
				this.goToPage(
					this.currentPage.pageX + this.directionX,
					this.currentPage.pageY + this.directionY,
					time
				);
			});
		},
	
		_nearestSnap: function (x, y) {
			if ( !this.pages.length ) {
				return { x: 0, y: 0, pageX: 0, pageY: 0 };
			}
	
			var i = 0,
				l = this.pages.length,
				m = 0;
	
			// Check if we exceeded the snap threshold
			if ( Math.abs(x - this.absStartX) < this.snapThresholdX &&
				Math.abs(y - this.absStartY) < this.snapThresholdY ) {
				return this.currentPage;
			}
	
			if ( x > 0 ) {
				x = 0;
			} else if ( x < this.maxScrollX ) {
				x = this.maxScrollX;
			}
	
			if ( y > 0 ) {
				y = 0;
			} else if ( y < this.maxScrollY ) {
				y = this.maxScrollY;
			}
	
			for ( ; i < l; i++ ) {
				if ( x >= this.pages[i][0].cx ) {
					x = this.pages[i][0].x;
					break;
				}
			}
	
			l = this.pages[i].length;
	
			for ( ; m < l; m++ ) {
				if ( y >= this.pages[0][m].cy ) {
					y = this.pages[0][m].y;
					break;
				}
			}
	
			if ( i == this.currentPage.pageX ) {
				i += this.directionX;
	
				if ( i < 0 ) {
					i = 0;
				} else if ( i >= this.pages.length ) {
					i = this.pages.length - 1;
				}
	
				x = this.pages[i][0].x;
			}
	
			if ( m == this.currentPage.pageY ) {
				m += this.directionY;
	
				if ( m < 0 ) {
					m = 0;
				} else if ( m >= this.pages[0].length ) {
					m = this.pages[0].length - 1;
				}
	
				y = this.pages[0][m].y;
			}
	
			return {
				x: x,
				y: y,
				pageX: i,
				pageY: m
			};
		},
	
		goToPage: function (x, y, time, easing) {
			easing = easing || this.options.bounceEasing;
	
			if ( x >= this.pages.length ) {
				x = this.pages.length - 1;
			} else if ( x < 0 ) {
				x = 0;
			}
	
			if ( y >= this.pages[x].length ) {
				y = this.pages[x].length - 1;
			} else if ( y < 0 ) {
				y = 0;
			}
	
			var posX = this.pages[x][y].x,
				posY = this.pages[x][y].y;
	
			time = time === undefined ? this.options.snapSpeed || Math.max(
				Math.max(
					Math.min(Math.abs(posX - this.x), 1000),
					Math.min(Math.abs(posY - this.y), 1000)
				), 300) : time;
	
			this.currentPage = {
				x: posX,
				y: posY,
				pageX: x,
				pageY: y
			};
	
			this.scrollTo(posX, posY, time, easing);
		},
	
		next: function (time, easing) {
			var x = this.currentPage.pageX,
				y = this.currentPage.pageY;
	
			x++;
	
			if ( x >= this.pages.length && this.hasVerticalScroll ) {
				x = 0;
				y++;
			}
	
			this.goToPage(x, y, time, easing);
		},
	
		prev: function (time, easing) {
			var x = this.currentPage.pageX,
				y = this.currentPage.pageY;
	
			x--;
	
			if ( x < 0 && this.hasVerticalScroll ) {
				x = 0;
				y--;
			}
	
			this.goToPage(x, y, time, easing);
		},
	
		_initKeys: function (e) {
			// default key bindings
			var keys = {
				pageUp: 33,
				pageDown: 34,
				end: 35,
				home: 36,
				left: 37,
				up: 38,
				right: 39,
				down: 40
			};
			var i;
	
			// if you give me characters I give you keycode
			if ( typeof this.options.keyBindings == 'object' ) {
				for ( i in this.options.keyBindings ) {
					if ( typeof this.options.keyBindings[i] == 'string' ) {
						this.options.keyBindings[i] = this.options.keyBindings[i].toUpperCase().charCodeAt(0);
					}
				}
			} else {
				this.options.keyBindings = {};
			}
	
			for ( i in keys ) {
				this.options.keyBindings[i] = this.options.keyBindings[i] || keys[i];
			}
	
			utils.addEvent(window, 'keydown', this);
	
			this.on('destroy', function () {
				utils.removeEvent(window, 'keydown', this);
			});
		},
	
		_key: function (e) {
			if ( !this.enabled ) {
				return;
			}
	
			var snap = this.options.snap,	// we are using this alot, better to cache it
				newX = snap ? this.currentPage.pageX : this.x,
				newY = snap ? this.currentPage.pageY : this.y,
				now = utils.getTime(),
				prevTime = this.keyTime || 0,
				acceleration = 0.250,
				pos;
	
			if ( this.options.useTransition && this.isInTransition ) {
				pos = this.getComputedPosition();
	
				this._translate(Math.round(pos.x), Math.round(pos.y));
				this.isInTransition = false;
			}
	
			this.keyAcceleration = now - prevTime < 200 ? Math.min(this.keyAcceleration + acceleration, 50) : 0;
	
			switch ( e.keyCode ) {
				case this.options.keyBindings.pageUp:
					if ( this.hasHorizontalScroll && !this.hasVerticalScroll ) {
						newX += snap ? 1 : this.wrapperWidth;
					} else {
						newY += snap ? 1 : this.wrapperHeight;
					}
					break;
				case this.options.keyBindings.pageDown:
					if ( this.hasHorizontalScroll && !this.hasVerticalScroll ) {
						newX -= snap ? 1 : this.wrapperWidth;
					} else {
						newY -= snap ? 1 : this.wrapperHeight;
					}
					break;
				case this.options.keyBindings.end:
					newX = snap ? this.pages.length-1 : this.maxScrollX;
					newY = snap ? this.pages[0].length-1 : this.maxScrollY;
					break;
				case this.options.keyBindings.home:
					newX = 0;
					newY = 0;
					break;
				case this.options.keyBindings.left:
					newX += snap ? -1 : 5 + this.keyAcceleration>>0;
					break;
				case this.options.keyBindings.up:
					newY += snap ? 1 : 5 + this.keyAcceleration>>0;
					break;
				case this.options.keyBindings.right:
					newX -= snap ? -1 : 5 + this.keyAcceleration>>0;
					break;
				case this.options.keyBindings.down:
					newY -= snap ? 1 : 5 + this.keyAcceleration>>0;
					break;
				default:
					return;
			}
	
			if ( snap ) {
				this.goToPage(newX, newY);
				return;
			}
	
			if ( newX > 0 ) {
				newX = 0;
				this.keyAcceleration = 0;
			} else if ( newX < this.maxScrollX ) {
				newX = this.maxScrollX;
				this.keyAcceleration = 0;
			}
	
			if ( newY > 0 ) {
				newY = 0;
				this.keyAcceleration = 0;
			} else if ( newY < this.maxScrollY ) {
				newY = this.maxScrollY;
				this.keyAcceleration = 0;
			}
	
			this.scrollTo(newX, newY, 0);
	
			this.keyTime = now;
		},
	
		_animate: function (destX, destY, duration, easingFn) {
			var that = this,
				startX = this.x,
				startY = this.y,
				startTime = utils.getTime(),
				destTime = startTime + duration;
	
			function step () {
				var now = utils.getTime(),
					newX, newY,
					easing;
	
				if ( now >= destTime ) {
					that.isAnimating = false;
					that._translate(destX, destY);
	
					if ( !that.resetPosition(that.options.bounceTime) ) {
						that._execEvent('scrollEnd');
					}
	
					return;
				}
	
				now = ( now - startTime ) / duration;
				easing = easingFn(now);
				newX = ( destX - startX ) * easing + startX;
				newY = ( destY - startY ) * easing + startY;
				that._translate(newX, newY);
	
				if ( that.isAnimating ) {
					rAF(step);
				}
			}
	
			this.isAnimating = true;
			step();
		},
		handleEvent: function (e) {
			switch ( e.type ) {
				case 'touchstart':
				case 'pointerdown':
				case 'MSPointerDown':
				case 'mousedown':
					this._start(e);
					break;
				case 'touchmove':
				case 'pointermove':
				case 'MSPointerMove':
				case 'mousemove':
					this._move(e);
					break;
				case 'touchend':
				case 'pointerup':
				case 'MSPointerUp':
				case 'mouseup':
				case 'touchcancel':
				case 'pointercancel':
				case 'MSPointerCancel':
				case 'mousecancel':
					this._end(e);
					break;
				case 'orientationchange':
				case 'resize':
					this._resize();
					break;
				case 'transitionend':
				case 'webkitTransitionEnd':
				case 'oTransitionEnd':
				case 'MSTransitionEnd':
					this._transitionEnd(e);
					break;
				case 'wheel':
				case 'DOMMouseScroll':
				case 'mousewheel':
					this._wheel(e);
					break;
				case 'keydown':
					this._key(e);
					break;
				case 'click':
					if ( this.enabled && !e._constructed ) {
						e.preventDefault();
						e.stopPropagation();
					}
					break;
			}
		}
	};
	function createDefaultScrollbar (direction, interactive, type) {
		var scrollbar = document.createElement('div'),
			indicator = document.createElement('div');
	
		if ( type === true ) {
			scrollbar.style.cssText = 'position:absolute;z-index:9999';
			indicator.style.cssText = '-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:absolute;background:rgba(0,0,0,0.5);border:1px solid rgba(255,255,255,0.9);border-radius:3px';
		}
	
		indicator.className = 'iScrollIndicator';
	
		if ( direction == 'h' ) {
			if ( type === true ) {
				scrollbar.style.cssText += ';height:7px;left:2px;right:2px;bottom:0';
				indicator.style.height = '100%';
			}
			scrollbar.className = 'iScrollHorizontalScrollbar';
		} else {
			if ( type === true ) {
				scrollbar.style.cssText += ';width:7px;bottom:2px;top:2px;right:1px';
				indicator.style.width = '100%';
			}
			scrollbar.className = 'iScrollVerticalScrollbar';
		}
	
		scrollbar.style.cssText += ';overflow:hidden';
	
		if ( !interactive ) {
			scrollbar.style.pointerEvents = 'none';
		}
	
		scrollbar.appendChild(indicator);
	
		return scrollbar;
	}
	
	function Indicator (scroller, options) {
		this.wrapper = typeof options.el == 'string' ? document.querySelector(options.el) : options.el;
		this.wrapperStyle = this.wrapper.style;
		this.indicator = this.wrapper.children[0];
		this.indicatorStyle = this.indicator.style;
		this.scroller = scroller;
	
		this.options = {
			listenX: true,
			listenY: true,
			interactive: false,
			resize: true,
			defaultScrollbars: false,
			shrink: false,
			fade: false,
			speedRatioX: 0,
			speedRatioY: 0
		};
	
		for ( var i in options ) {
			this.options[i] = options[i];
		}
	
		this.sizeRatioX = 1;
		this.sizeRatioY = 1;
		this.maxPosX = 0;
		this.maxPosY = 0;
	
		if ( this.options.interactive ) {
			if ( !this.options.disableTouch ) {
				utils.addEvent(this.indicator, 'touchstart', this);
				utils.addEvent(window, 'touchend', this);
			}
			if ( !this.options.disablePointer ) {
				utils.addEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
				utils.addEvent(window, utils.prefixPointerEvent('pointerup'), this);
			}
			if ( !this.options.disableMouse ) {
				utils.addEvent(this.indicator, 'mousedown', this);
				utils.addEvent(window, 'mouseup', this);
			}
		}
	
		if ( this.options.fade ) {
			this.wrapperStyle[utils.style.transform] = this.scroller.translateZ;
			var durationProp = utils.style.transitionDuration;
			this.wrapperStyle[durationProp] = utils.isBadAndroid ? '0.0001ms' : '0ms';
			// remove 0.0001ms
			var self = this;
			if(utils.isBadAndroid) {
				rAF(function() {
					if(self.wrapperStyle[durationProp] === '0.0001ms') {
						self.wrapperStyle[durationProp] = '0s';
					}
				});
			}
			this.wrapperStyle.opacity = '0';
		}
	}
	
	Indicator.prototype = {
		handleEvent: function (e) {
			switch ( e.type ) {
				case 'touchstart':
				case 'pointerdown':
				case 'MSPointerDown':
				case 'mousedown':
					this._start(e);
					break;
				case 'touchmove':
				case 'pointermove':
				case 'MSPointerMove':
				case 'mousemove':
					this._move(e);
					break;
				case 'touchend':
				case 'pointerup':
				case 'MSPointerUp':
				case 'mouseup':
				case 'touchcancel':
				case 'pointercancel':
				case 'MSPointerCancel':
				case 'mousecancel':
					this._end(e);
					break;
			}
		},
	
		destroy: function () {
			if ( this.options.fadeScrollbars ) {
				clearTimeout(this.fadeTimeout);
				this.fadeTimeout = null;
			}
			if ( this.options.interactive ) {
				utils.removeEvent(this.indicator, 'touchstart', this);
				utils.removeEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
				utils.removeEvent(this.indicator, 'mousedown', this);
	
				utils.removeEvent(window, 'touchmove', this);
				utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
				utils.removeEvent(window, 'mousemove', this);
	
				utils.removeEvent(window, 'touchend', this);
				utils.removeEvent(window, utils.prefixPointerEvent('pointerup'), this);
				utils.removeEvent(window, 'mouseup', this);
			}
	
			if ( this.options.defaultScrollbars ) {
				this.wrapper.parentNode.removeChild(this.wrapper);
			}
		},
	
		_start: function (e) {
			var point = e.touches ? e.touches[0] : e;
	
			e.preventDefault();
			e.stopPropagation();
	
			this.transitionTime();
	
			this.initiated = true;
			this.moved = false;
			this.lastPointX	= point.pageX;
			this.lastPointY	= point.pageY;
	
			this.startTime	= utils.getTime();
	
			if ( !this.options.disableTouch ) {
				utils.addEvent(window, 'touchmove', this);
			}
			if ( !this.options.disablePointer ) {
				utils.addEvent(window, utils.prefixPointerEvent('pointermove'), this);
			}
			if ( !this.options.disableMouse ) {
				utils.addEvent(window, 'mousemove', this);
			}
	
			this.scroller._execEvent('beforeScrollStart');
		},
	
		_move: function (e) {
			var point = e.touches ? e.touches[0] : e,
				deltaX, deltaY,
				newX, newY,
				timestamp = utils.getTime();
	
			if ( !this.moved ) {
				this.scroller._execEvent('scrollStart');
			}
	
			this.moved = true;
	
			deltaX = point.pageX - this.lastPointX;
			this.lastPointX = point.pageX;
	
			deltaY = point.pageY - this.lastPointY;
			this.lastPointY = point.pageY;
	
			newX = this.x + deltaX;
			newY = this.y + deltaY;
	
			this._pos(newX, newY);
	
	// INSERT POINT: indicator._move
	
			e.preventDefault();
			e.stopPropagation();
		},
	
		_end: function (e) {
			if ( !this.initiated ) {
				return;
			}
	
			this.initiated = false;
	
			e.preventDefault();
			e.stopPropagation();
	
			utils.removeEvent(window, 'touchmove', this);
			utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
			utils.removeEvent(window, 'mousemove', this);
	
			if ( this.scroller.options.snap ) {
				var snap = this.scroller._nearestSnap(this.scroller.x, this.scroller.y);
	
				var time = this.options.snapSpeed || Math.max(
						Math.max(
							Math.min(Math.abs(this.scroller.x - snap.x), 1000),
							Math.min(Math.abs(this.scroller.y - snap.y), 1000)
						), 300);
	
				if ( this.scroller.x != snap.x || this.scroller.y != snap.y ) {
					this.scroller.directionX = 0;
					this.scroller.directionY = 0;
					this.scroller.currentPage = snap;
					this.scroller.scrollTo(snap.x, snap.y, time, this.scroller.options.bounceEasing);
				}
			}
	
			if ( this.moved ) {
				this.scroller._execEvent('scrollEnd');
			}
		},
	
		transitionTime: function (time) {
			time = time || 0;
			var durationProp = utils.style.transitionDuration;
			this.indicatorStyle[durationProp] = time + 'ms';
	
			if ( !time && utils.isBadAndroid ) {
				this.indicatorStyle[durationProp] = '0.0001ms';
				// remove 0.0001ms
				var self = this;
				rAF(function() {
					if(self.indicatorStyle[durationProp] === '0.0001ms') {
						self.indicatorStyle[durationProp] = '0s';
					}
				});
			}
		},
	
		transitionTimingFunction: function (easing) {
			this.indicatorStyle[utils.style.transitionTimingFunction] = easing;
		},
	
		refresh: function () {
			this.transitionTime();
	
			if ( this.options.listenX && !this.options.listenY ) {
				this.indicatorStyle.display = this.scroller.hasHorizontalScroll ? 'block' : 'none';
			} else if ( this.options.listenY && !this.options.listenX ) {
				this.indicatorStyle.display = this.scroller.hasVerticalScroll ? 'block' : 'none';
			} else {
				this.indicatorStyle.display = this.scroller.hasHorizontalScroll || this.scroller.hasVerticalScroll ? 'block' : 'none';
			}
	
			if ( this.scroller.hasHorizontalScroll && this.scroller.hasVerticalScroll ) {
				utils.addClass(this.wrapper, 'iScrollBothScrollbars');
				utils.removeClass(this.wrapper, 'iScrollLoneScrollbar');
	
				if ( this.options.defaultScrollbars && this.options.customStyle ) {
					if ( this.options.listenX ) {
						this.wrapper.style.right = '8px';
					} else {
						this.wrapper.style.bottom = '8px';
					}
				}
			} else {
				utils.removeClass(this.wrapper, 'iScrollBothScrollbars');
				utils.addClass(this.wrapper, 'iScrollLoneScrollbar');
	
				if ( this.options.defaultScrollbars && this.options.customStyle ) {
					if ( this.options.listenX ) {
						this.wrapper.style.right = '2px';
					} else {
						this.wrapper.style.bottom = '2px';
					}
				}
			}
	
			var r = this.wrapper.offsetHeight;	// force refresh
	
			if ( this.options.listenX ) {
				this.wrapperWidth = this.wrapper.clientWidth;
				if ( this.options.resize ) {
					this.indicatorWidth = Math.max(Math.round(this.wrapperWidth * this.wrapperWidth / (this.scroller.scrollerWidth || this.wrapperWidth || 1)), 8);
					this.indicatorStyle.width = this.indicatorWidth + 'px';
				} else {
					this.indicatorWidth = this.indicator.clientWidth;
				}
	
				this.maxPosX = this.wrapperWidth - this.indicatorWidth;
	
				if ( this.options.shrink == 'clip' ) {
					this.minBoundaryX = -this.indicatorWidth + 8;
					this.maxBoundaryX = this.wrapperWidth - 8;
				} else {
					this.minBoundaryX = 0;
					this.maxBoundaryX = this.maxPosX;
				}
	
				this.sizeRatioX = this.options.speedRatioX || (this.scroller.maxScrollX && (this.maxPosX / this.scroller.maxScrollX));
			}
	
			if ( this.options.listenY ) {
				this.wrapperHeight = this.wrapper.clientHeight;
				if ( this.options.resize ) {
					this.indicatorHeight = Math.max(Math.round(this.wrapperHeight * this.wrapperHeight / (this.scroller.scrollerHeight || this.wrapperHeight || 1)), 8);
					this.indicatorStyle.height = this.indicatorHeight + 'px';
				} else {
					this.indicatorHeight = this.indicator.clientHeight;
				}
	
				this.maxPosY = this.wrapperHeight - this.indicatorHeight;
	
				if ( this.options.shrink == 'clip' ) {
					this.minBoundaryY = -this.indicatorHeight + 8;
					this.maxBoundaryY = this.wrapperHeight - 8;
				} else {
					this.minBoundaryY = 0;
					this.maxBoundaryY = this.maxPosY;
				}
	
				this.maxPosY = this.wrapperHeight - this.indicatorHeight;
				this.sizeRatioY = this.options.speedRatioY || (this.scroller.maxScrollY && (this.maxPosY / this.scroller.maxScrollY));
			}
	
			this.updatePosition();
		},
	
		updatePosition: function () {
			var x = this.options.listenX && Math.round(this.sizeRatioX * this.scroller.x) || 0,
				y = this.options.listenY && Math.round(this.sizeRatioY * this.scroller.y) || 0;
	
			if ( !this.options.ignoreBoundaries ) {
				if ( x < this.minBoundaryX ) {
					if ( this.options.shrink == 'scale' ) {
						this.width = Math.max(this.indicatorWidth + x, 8);
						this.indicatorStyle.width = this.width + 'px';
					}
					x = this.minBoundaryX;
				} else if ( x > this.maxBoundaryX ) {
					if ( this.options.shrink == 'scale' ) {
						this.width = Math.max(this.indicatorWidth - (x - this.maxPosX), 8);
						this.indicatorStyle.width = this.width + 'px';
						x = this.maxPosX + this.indicatorWidth - this.width;
					} else {
						x = this.maxBoundaryX;
					}
				} else if ( this.options.shrink == 'scale' && this.width != this.indicatorWidth ) {
					this.width = this.indicatorWidth;
					this.indicatorStyle.width = this.width + 'px';
				}
	
				if ( y < this.minBoundaryY ) {
					if ( this.options.shrink == 'scale' ) {
						this.height = Math.max(this.indicatorHeight + y * 3, 8);
						this.indicatorStyle.height = this.height + 'px';
					}
					y = this.minBoundaryY;
				} else if ( y > this.maxBoundaryY ) {
					if ( this.options.shrink == 'scale' ) {
						this.height = Math.max(this.indicatorHeight - (y - this.maxPosY) * 3, 8);
						this.indicatorStyle.height = this.height + 'px';
						y = this.maxPosY + this.indicatorHeight - this.height;
					} else {
						y = this.maxBoundaryY;
					}
				} else if ( this.options.shrink == 'scale' && this.height != this.indicatorHeight ) {
					this.height = this.indicatorHeight;
					this.indicatorStyle.height = this.height + 'px';
				}
			}
	
			this.x = x;
			this.y = y;
	
			if ( this.scroller.options.useTransform ) {
				this.indicatorStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.scroller.translateZ;
			} else {
				this.indicatorStyle.left = x + 'px';
				this.indicatorStyle.top = y + 'px';
			}
		},
	
		_pos: function (x, y) {
			if ( x < 0 ) {
				x = 0;
			} else if ( x > this.maxPosX ) {
				x = this.maxPosX;
			}
	
			if ( y < 0 ) {
				y = 0;
			} else if ( y > this.maxPosY ) {
				y = this.maxPosY;
			}
	
			x = this.options.listenX ? Math.round(x / this.sizeRatioX) : this.scroller.x;
			y = this.options.listenY ? Math.round(y / this.sizeRatioY) : this.scroller.y;
	
			this.scroller.scrollTo(x, y);
		},
	
		fade: function (val, hold) {
			if ( hold && !this.visible ) {
				return;
			}
	
			clearTimeout(this.fadeTimeout);
			this.fadeTimeout = null;
	
			var time = val ? 250 : 500,
				delay = val ? 0 : 300;
	
			val = val ? '1' : '0';
	
			this.wrapperStyle[utils.style.transitionDuration] = time + 'ms';
	
			this.fadeTimeout = setTimeout((function (val) {
				this.wrapperStyle.opacity = val;
				this.visible = +val;
			}).bind(this, val), delay);
		}
	};
	
	IScroll.utils = utils;
	
	if ( typeof module != 'undefined' && module.exports ) {
		module.exports = IScroll;
	} else if ( true ) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () { return IScroll; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.IScroll = IScroll;
	}
	
	})(window, document, Math);


/***/ },

/***/ 312:
/***/ function(module, exports) {

	module.exports = "<div v-show=!showManager class=home> <div class=top-action> <top-search :searchtype=searchtype :keyword.sync=keyword :keyword-change=keywordChange></top-search> <menu v-if=isShowMenu :menu-list=menuList :cateid=cateid :is-show-menu.sync=isShowMenu @change=onMenuChange></menu> <navigationbar :menu-list=menuList :cateid=cateid :is-show-menu.sync=isShowMenu @change=onMenuChange></navigationbar> </div> <div class=info-msg> <slideload :slidemessage=paramArr></slideload> </div> </div> <search-manager v-show=showManager v-el:manager></search-manager>";

/***/ },

/***/ 313:
/***/ function(module, exports) {

	module.exports = "<div class=menu transition=menu-side> <a @click=onNavClick(null) class=menu-all>全部 <span class=all-span></span></a> <ul class=menu-list> <li v-for=\"item in menuList\"> <a :class=\"{'active' : cateid == item.cateid }\" @click=onNavClick(item.cateid)> <span class=menu-keyword>{{item.cateName}}</span> <span class=menu-keyinfo>{{item.subName}}</span> </a> </li> </ul> </div>";

/***/ },

/***/ 314:
/***/ function(module, exports) {

	module.exports = "<div class=home-nav> <div v-el:scroll class=home-nav-scroll> <ul class=home-nav-list> <li v-for=\"(index,item) in menuList\"> <a :class=\"{'active' : cateid == item.cateid}\" :href=item.href v-touch:tap=onNavTap(index,item.cateid)>{{item.cateName}}</a> </li> </ul> </div> <a class=down @click=onShowMenuClick></a> </div>";

/***/ },

/***/ 347:
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(222)
	__vue_script__ = __webpack_require__(121)
	__vue_template__ = __webpack_require__(312)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },

/***/ 348:
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(223)
	__vue_script__ = __webpack_require__(122)
	__vue_template__ = __webpack_require__(313)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },

/***/ 349:
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(224)
	__vue_script__ = __webpack_require__(123)
	__vue_template__ = __webpack_require__(314)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ }

});


/** WEBPACK FOOTER **
 ** static/js/4.806794db0983ca9b708b.js
 **/